<!-- app-subdomain-creators/src/accountPages/CreatorAnalytics.vue -->
<template>
  <div class="w-full px-6 lg:px-8 py-4">
    <CreatorAnalyticsNewsfeedViewers
      :is-open="isViewersModalOpen"
      :post-id="selectedViewerPostId"
      :is-loading="isLoadingViewers"
      :error="viewersError"
      :rows="viewerRows"
      @close="closeViewersModal"
    />
    <CreatorCourseCertificateViewerModal
      v-model:open="certificateViewerOpen"
      :pdf-src="certificateViewerPdfSrc"
      :download-url="certificateViewerDownloadUrl"
      title="Member Course Certificate"
    />

    <div class="">
      <nav
        class="flex gap-6 overflow-x-auto whitespace-nowrap"
        aria-label="Analytics Tabs"
      >
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'overview'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'overview'"
        >
          Overview
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'members'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'members'"
        >
          Members
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'broadcasts'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'broadcasts'"
        >
          Broadcasts
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'webinars'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'webinars'"
        >
          Webinars
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'newsfeed-posts'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'newsfeed-posts'"
        >
          Newsfeed Posts
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'course-progress'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'course-progress'"
        >
          Course Progress
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'video-channels'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'video-channels'"
        >
          Video Channels
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'quizzes'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'quizzes'"
        >
          Quizzes
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'podcasts'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'podcasts'"
        >
          Podcasts
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'flix-theatres'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'flix-theatres'"
        >
          Flix Theatres
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'stores'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'stores'"
        >
          Stores
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'payment-analytics'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'payment-analytics'"
        >
          Payment Analytics
        </button>
        <button
          type="button"
          class="py-3 px-1 border-b-2 text-sm font-medium"
          :class="activeTab === 'crypto'
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="activeTab = 'crypto'"
        >
          Crypto
        </button>
      </nav>
    </div>

    <div
      v-show="activeTab === 'overview'"
      class="pt-4"
    >
      <div class="grid items-start gap-4 xl:grid-cols-[minmax(0,1fr)_360px]">
        <div class="overview-map-panel relative isolate self-start overflow-hidden rounded-xl border border-zinc-200 bg-[#dce8f1] shadow-sm">
          <div
            id="overview-analytics-map"
            class="h-full w-full"
          />

          <div
            v-if="isLoadingOverviewMap"
            class="pointer-events-none absolute left-4 top-4 z-50 rounded-lg bg-black/55 px-3 py-1 text-xs font-medium text-white"
          >
            Loading map data...
          </div>

          <div
            v-if="overviewMapError"
            class="pointer-events-none absolute right-4 top-4 z-30 rounded-lg bg-red-500/85 px-3 py-1 text-xs font-medium text-white"
          >
            {{ overviewMapError }}
          </div>

          <div class="absolute bottom-4 left-4 z-20 w-[min(92vw,380px)] rounded-xl border border-white/80 bg-white/90 p-4 shadow-[0_14px_38px_rgba(45,72,92,0.18)] backdrop-blur-md">
            <div class="flex items-start justify-between gap-3">
              <h3 class="min-w-[170px] text-lg font-medium text-zinc-900">
                {{ overviewWindowTitle }}
              </h3>
              <div class="inline-flex rounded-lg border border-zinc-200 bg-white/80 p-1 text-xs font-medium text-zinc-600">
                <button
                  type="button"
                  class="w-14 rounded-md px-2 py-1 text-center transition"
                  :class="overviewWindow === 'last30' ? 'bg-[#2D8CFF] text-white shadow-sm' : 'hover:bg-zinc-100'"
                  @click="overviewWindow = 'last30'"
                >
                  30m
                </button>
                <button
                  type="button"
                  class="w-14 rounded-md px-2 py-1 text-center transition"
                  :class="overviewWindow === 'live' ? 'bg-[#2D8CFF] text-white shadow-sm' : 'hover:bg-zinc-100'"
                  @click="overviewWindow = 'live'"
                >
                  Live
                </button>
              </div>
            </div>
            <p class="mt-2 text-3xl font-semibold text-zinc-900">
              {{ totalUsers }}
            </p>
            <p class="mt-1 text-xs font-medium uppercase tracking-wide text-zinc-500">
              Unique Users
            </p>
            <div class="mt-4">
              <p class="text-sm text-zinc-600">
                {{ overviewWindowDeviceTitle }}
              </p>
              <div class="mt-3 flex justify-between gap-8">
                <div class="flex flex-col items-center">
                  <div class="flex items-center gap-2">
                    <span class="inline-block h-4 w-4 rounded-full bg-[#2D8CFF]" />
                    <span class="text-sm text-zinc-700">Desktop</span>
                  </div>
                  <span class="mt-1 text-lg font-semibold text-zinc-900">{{ desktopPercentage }}%</span>
                </div>
                <div class="flex flex-col items-center">
                  <div class="flex items-center gap-2">
                    <span class="inline-block h-4 w-4 rounded-full bg-[#72AEFF]" />
                    <span class="text-sm text-zinc-700">Mobile</span>
                  </div>
                  <span class="mt-1 text-lg font-semibold text-zinc-900">{{ mobilePercentage }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CreatorMemberActivityStream class="overview-activity-panel self-start overflow-hidden" />
      </div>
    </div>

    <div
      v-show="activeTab === 'members'"
      class="pt-4"
    >
      <div class="flex flex-wrap items-center gap-3 mb-4">
        <label class="text-sm text-zinc-700 font-medium">Range</label>
        <PlatformaSelect
          v-model="membersRangeKey"
          :options="membersRangeOptions"
          class="min-w-[220px]"
        />
        <input
          v-if="membersRangeKey === 'custom'"
          v-model="membersCustomFrom"
          type="date"
          class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-0"
        >
        <input
          v-if="membersRangeKey === 'custom'"
          v-model="membersCustomTo"
          type="date"
          class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-0"
        >
        <button
          type="button"
          class="h-10 px-4 rounded-lg bg-zinc-100 hover:bg-zinc-200 text-sm font-semibold text-zinc-800"
          @click="loadMembersAnalytics"
        >
          Refresh
        </button>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3 mb-4">
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Members Added
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ membersSummary.membersAddedCount }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Members Lost
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ membersSummary.membersLostCount }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            On Subscription
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ membersSummary.onSubscriptionCount }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Payment Failed
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ membersSummary.paymentsFailedCount }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Canceled
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ membersSummary.subscriptionsCanceledCount }}
          </p>
        </div>
      </div>

      <div class="rounded-xl border border-zinc-200 bg-white p-4">
        <div class="flex items-center justify-between gap-3">
          <div>
            <h3 class="text-sm font-semibold text-zinc-900">
              Members Lifecycle Bar Graph
            </h3>
            <p class="mt-1 text-xs text-zinc-500">
              Leads, members, subscription lifecycle, and payment outcomes in the selected range.
            </p>
          </div>
        </div>

        <div
          v-if="isLoadingMembersAnalytics"
          class="mt-5 rounded-lg bg-zinc-50 px-4 py-6 text-sm text-zinc-500"
        >
          Loading members analytics...
        </div>
        <div
          v-else-if="membersAnalyticsError"
          class="mt-5 rounded-lg bg-red-50 px-4 py-6 text-sm text-red-600"
        >
          {{ membersAnalyticsError }}
        </div>
        <div
          v-else
          class="mt-5 space-y-3"
        >
          <div
            v-for="bar in membersBars"
            :key="bar.key"
            class="grid grid-cols-[220px,1fr,80px] items-center gap-3"
          >
            <p class="truncate text-sm font-medium text-zinc-700">
              {{ bar.label }}
            </p>
            <div class="h-8 rounded-lg bg-zinc-100 overflow-hidden">
              <div
                class="h-full rounded-lg bg-[#2D8CFF] transition-all duration-300"
                :style="{ width: Number(bar.count || 0) > 0 ? `${Math.max(4, Math.round((Number(bar.count || 0) / membersBarMaxCount) * 100))}%` : '0%' }"
              />
            </div>
            <p class="text-right text-sm font-semibold text-zinc-900">
              {{ bar.count }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-show="activeTab === 'broadcasts'" class="pt-4">
      <CreatorBroadcastAnalytics :active="activeTab === 'broadcasts'" />
    </div>

    <div v-show="activeTab === 'webinars'" class="pt-4">
      <CreatorWebinarAnalytics />
    </div>

    <div
      v-show="activeTab === 'newsfeed-posts'"
      class="pt-4"
    >
      <div class="flex flex-wrap items-center gap-3 mb-4">
        <label class="text-sm text-zinc-700 font-medium">Newsfeed</label>
        <PlatformaSelect
          v-model="selectedInstanceId"
          :options="newsfeedSelectOptions"
          :disabled="!newsfeedSelectOptions.length"
          :placeholder="newsfeedSelectOptions.length ? 'Select Newsfeed' : 'No Newsfeed instances found'"
          class="min-w-[260px]"
        />
        <button
          type="button"
          class="h-10 px-4 rounded-lg bg-zinc-100 hover:bg-zinc-200 text-sm font-semibold text-zinc-800"
          @click="loadPostViewAnalytics"
        >
          Refresh
        </button>
        <div class="ml-2 inline-flex items-center gap-3 text-sm text-zinc-700 select-none">
          <span>Include creator views</span>
          <button
            type="button"
            role="switch"
            :aria-checked="includeCreatorViews ? 'true' : 'false'"
            class="relative inline-flex h-7 w-12 items-center rounded-full transition-colors"
            :class="includeCreatorViews ? 'bg-[#2D8CFF]' : 'bg-zinc-300'"
            @click="includeCreatorViews = !includeCreatorViews"
          >
            <span
              class="inline-block h-5 w-5 transform rounded-full bg-white transition"
              :class="includeCreatorViews ? 'translate-x-6' : 'translate-x-1'"
            />
          </button>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3 mb-4">
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Total Views
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ analyticsTotals.totalViews }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Unique Viewers
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ analyticsTotals.uniqueViewers }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Feed Views
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ analyticsTotals.feedViews }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Clicked To Open
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ analyticsTotals.slugViews }}
          </p>
        </div>
      </div>

      <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
        <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
          Top Post Views
        </div>

        <div
          v-if="!newsfeedInstances.length && !isLoadingAnalytics"
          class="px-4 py-8 text-sm text-zinc-500"
        >
          No Newsfeed feature instances were found for this account.
        </div>
        <div
          v-if="isLoadingAnalytics"
          class="px-4 py-8 text-sm text-zinc-500"
        >
          Loading post analytics...
        </div>
        <div
          v-else-if="analyticsError"
          class="px-4 py-8 text-sm text-red-600"
        >
          {{ analyticsError }}
        </div>
        <div
          v-else-if="!analyticsPosts.length"
          class="px-4 py-8 text-sm text-zinc-500"
        >
          No post views recorded yet.
        </div>

        <div
          v-else
          class="overflow-x-auto"
        >
          <table class="min-w-full text-sm">
            <thead class="bg-zinc-50 text-zinc-600">
              <tr>
                <th class="text-left px-4 py-2 font-medium">
                  Post
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Views
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Unique
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Feed
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Clicked To Open
                </th>
                <th class="text-left px-4 py-2 font-medium">
                  Last Viewed
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Viewers
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in analyticsPosts"
                :key="row.postId"
                class="border-t border-zinc-100 hover:bg-zinc-50"
              >
                <td class="px-4 py-2">
                  <button
                    type="button"
                    class="font-medium truncate max-w-[340px] text-left"
                    :class="row.slug
                      ? 'text-zinc-800 hover:text-[#2D8CFF] hover:underline'
                      : 'text-zinc-400 cursor-default'"
                    @click="openPostBySlug(row.slug)"
                  >
                    {{ row.contentPreview || '(No text)' }}
                  </button>
                </td>
                <td class="px-4 py-2 text-right text-zinc-800">
                  {{ row.totalViews }}
                </td>
                <td class="px-4 py-2 text-right text-zinc-800">
                  {{ row.uniqueViewers }}
                </td>
                <td class="px-4 py-2 text-right text-zinc-800">
                  {{ row.feedViews }}
                </td>
                <td class="px-4 py-2 text-right text-zinc-800">
                  {{ row.slugViews }}
                </td>
                <td class="px-4 py-2 text-zinc-600">
                  {{ formatDateTime(row.lastViewedAt) }}
                </td>
                <td class="px-4 py-2 text-right">
                  <button
                    type="button"
                    class="px-3 py-1.5 rounded-lg bg-zinc-100 hover:bg-zinc-200 text-xs font-semibold text-zinc-800"
                    @click="openViewersModal(row.postId)"
                  >
                    Inspect
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      v-show="activeTab === 'course-progress'"
      class="pt-4"
    >
      <div class="flex flex-wrap items-center gap-3 mb-4">
        <label class="text-sm text-zinc-700 font-medium">Course</label>
        <PlatformaSelect
          v-model="selectedCourseInstanceId"
          :options="courseSelectOptions"
          class="min-w-[260px]"
        />
        <input
          v-model="courseMemberSearch"
          type="text"
          placeholder="Search member..."
          class="h-10 min-w-[220px] rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800"
        >
        <button
          type="button"
          class="h-10 px-4 rounded-lg bg-zinc-100 hover:bg-zinc-200 text-sm font-semibold text-zinc-800"
          @click="loadCourseProgressAnalytics"
        >
          Refresh
        </button>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-4">
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Enrolled
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ courseProgressTotals.enrolledMembers }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Started
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ courseProgressTotals.startedMembers }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Completed
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ courseProgressTotals.completedMembers }}
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Avg Completion
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ courseProgressTotals.avgCompletionPercent }}%
          </p>
        </div>
        <div class="rounded-xl border border-zinc-200 bg-white p-4">
          <p class="text-xs uppercase tracking-wide text-zinc-500">
            Certificates Generated
          </p>
          <p class="text-2xl font-semibold text-zinc-900 mt-1">
            {{ courseProgressTotals.certificatesGenerated }}
          </p>
        </div>
      </div>

      <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
        <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
          Member Course Progress
        </div>

        <div
          v-if="isLoadingCourseProgress"
          class="px-4 py-8 text-sm text-zinc-500"
        >
          Loading course progress analytics...
        </div>
        <div
          v-else-if="courseProgressError"
          class="px-4 py-8 text-sm text-red-600"
        >
          {{ courseProgressError }}
        </div>
        <div
          v-else-if="!courseProgressRows.length"
          class="px-4 py-8 text-sm text-zinc-500"
        >
          No course progress records yet.
        </div>

        <div
          v-else
          class="overflow-x-auto"
        >
          <table class="min-w-full text-sm">
            <thead class="bg-zinc-50 text-zinc-600">
              <tr>
                <th class="text-left px-4 py-2 font-medium">
                  Member
                </th>
                <th class="text-left px-4 py-2 font-medium">
                  Course
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Completion
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Lessons
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Watch Time
                </th>
                <th class="text-left px-4 py-2 font-medium">
                  Last Activity
                </th>
                <th class="text-left px-4 py-2 font-medium">
                  Certificate
                </th>
                <th class="text-right px-4 py-2 font-medium">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in courseProgressRows"
                :key="row.id"
                class="border-t border-zinc-100 hover:bg-zinc-50"
              >
                <td class="px-4 py-2 text-zinc-900">
                  {{ row.memberName }}
                </td>
                <td class="px-4 py-2 text-zinc-700">
                  {{ row.courseName }}
                </td>
                <td class="px-4 py-2 text-right text-zinc-800">
                  {{ row.completionPercent }}%
                </td>
                <td class="px-4 py-2 text-right text-zinc-800">
                  {{ row.lessonsCompleted }} / {{ row.lessonsTotal }}
                </td>
                <td class="px-4 py-2 text-right text-zinc-800">
                  {{ row.watchMinutes }}m
                </td>
                <td class="px-4 py-2 text-zinc-600">
                  {{ formatDateTime(row.lastActivityAt) }}
                </td>
                <td class="px-4 py-2 text-zinc-600">
                  <span
                    v-if="row.hasCertificate"
                    class="inline-flex items-center rounded-md bg-emerald-50 px-2 py-1 text-xs font-semibold text-emerald-700 ring-1 ring-inset ring-emerald-600/20"
                  >
                    Issued
                  </span>
                  <span v-else>-</span>
                </td>
                <td class="px-4 py-2 text-right">
                  <button
                    type="button"
                    class="px-3 py-1.5 rounded-lg bg-zinc-100 hover:bg-zinc-200 text-xs font-semibold text-zinc-800 disabled:opacity-50 disabled:cursor-not-allowed"
                    :disabled="!row.hasCertificate"
                    @click="viewMemberCertificate(row)"
                  >
                    View Cert
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <CreatorQuizAnalytics
      v-show="activeTab === 'quizzes'"
      :active="activeTab === 'quizzes'"
      class="pt-4"
    />

    <div
      v-show="activeTab === 'video-channels'"
      class="pt-4 space-y-4"
    >
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 class="text-lg font-semibold text-zinc-900">
            Video Channel Analytics
          </h3>
          <p class="text-sm text-zinc-500 mt-0.5">
            {{ selectedVideoChannelLabel }}
          </p>
          <p
            v-if="videoChannelRangeDisplay"
            class="text-xs text-zinc-500 mt-0.5"
          >
            {{ videoChannelRangeDisplay }}
          </p>
        </div>
        <button
          type="button"
          class="h-10 px-4 rounded-full text-sm font-semibold transition"
          :class="videoChannelAdvancedMode
            ? 'bg-[#2D8CFF] text-white'
            : 'bg-zinc-100 text-zinc-800 hover:bg-zinc-200'"
          @click="videoChannelAdvancedMode = !videoChannelAdvancedMode"
        >
          {{ videoChannelAdvancedMode ? 'Exit Advanced Mode' : 'Advanced Mode' }}
        </button>
      </div>

      <div class="rounded-xl border border-zinc-200 bg-white p-4">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Channel</span>
            <PlatformaSelect
              v-model="selectedVideoChannelInstanceId"
              :options="videoChannelSelectOptions"
            />
          </label>

          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Range</span>
            <PlatformaSelect
              v-model="videoChannelRangeKey"
              :options="videoChannelRangeOptions"
            />
          </label>

          <label
            v-if="videoChannelRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">From</span>
            <input
              v-model="videoChannelCustomFrom"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>

          <label
            v-if="videoChannelRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">To</span>
            <input
              v-model="videoChannelCustomTo"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>

          <div class="flex items-end">
            <button
              type="button"
              class="h-10 w-full rounded-lg bg-zinc-100 hover:bg-zinc-200 text-sm font-semibold text-zinc-800"
              @click="loadVideoChannelAnalytics"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="isLoadingVideoChannelAnalytics"
        class="rounded-xl border border-zinc-200 bg-white px-4 py-10 flex items-center justify-center gap-3 text-zinc-600"
      >
        <span class="h-5 w-5 animate-spin rounded-full border-2 border-[#2D8CFF]/30 border-t-[#2D8CFF]" />
        <span class="text-sm font-medium">Loading video channel analytics...</span>
      </div>
      <div
        v-else-if="videoChannelAnalyticsError"
        class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
      >
        {{ videoChannelAnalyticsError }}
      </div>

      <template v-else>
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-6 gap-3">
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Views
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ videoChannelTotals.views }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Impressions
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ videoChannelTotals.impressions }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Watch Time (hours)
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatHours(videoChannelTotals.watchTimeHours) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Avg View Duration
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatDuration(videoChannelTotals.avgViewDurationSeconds) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Avg Percent Viewed
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatPercent(videoChannelTotals.avgPercentViewed) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Top Viewers (members)
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ videoChannelTopViewers.length }}
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Viewers - Members
            </div>
            <div
              v-if="!videoChannelTopViewers.length"
              class="px-4 py-8 text-sm text-zinc-500"
            >
              No viewer activity yet for this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Member
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Impressions
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Watch Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="viewer in videoChannelTopViewers"
                    :key="`video-channel-viewer-${viewer.memberId}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ viewer.memberName }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ viewer.views }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ viewer.impressions }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatHours(viewer.watchTimeHours) }}h
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Most Watched Videos
            </div>
            <div
              v-if="!videoChannelTopVideos.length"
              class="px-4 py-8 text-sm text-zinc-500"
            >
              No video watch sessions recorded yet.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Video
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Watch Time
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Avg Duration
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Avg %
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="video in videoChannelTopVideos"
                    :key="`video-channel-top-video-${video.videoId}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900 max-w-[340px] truncate">
                      {{ video.title }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ video.views }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatHours(video.watchTimeHours) }}h
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatDuration(video.avgViewDurationSeconds) }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatPercent(video.avgPercentViewed) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          v-if="videoChannelAdvancedMode"
          class="grid grid-cols-1 xl:grid-cols-2 gap-4"
        >
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Reach Timeline
            </div>
            <div
              v-if="!videoChannelTimeseries.length"
              class="px-4 py-8 text-sm text-zinc-500"
            >
              No timeline data for the selected range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Day
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Impressions
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Watch Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="point in videoChannelTimeseries"
                    :key="`video-channel-day-${point.day}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-700">
                      {{ formatDate(point.day) }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ point.impressions }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ point.views }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatHours(point.watchTimeHours) }}h
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Channel Breakdown
            </div>
            <div
              v-if="!videoChannelByChannel.length"
              class="px-4 py-8 text-sm text-zinc-500"
            >
              No channel-level data for the selected range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Channel
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Impressions
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Avg %
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in videoChannelByChannel"
                    :key="`video-channel-breakdown-${row.featureInstanceId}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ row.channelTitle }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ row.views }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.impressions }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatPercent(row.avgPercentViewed) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </div>

    <CreatorPodcastAnalytics
      v-show="activeTab === 'podcasts'"
      :active="activeTab === 'podcasts'"
      class="pt-4"
    />

    <div
      v-show="activeTab === 'flix-theatres'"
      class="pt-4 space-y-4"
    >
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 class="text-lg font-semibold text-zinc-900">
            Flix Theatre Analytics
          </h3>
          <p class="text-sm text-zinc-500 mt-0.5">
            {{ selectedFlixTheatreLabel }}
          </p>
          <p
            v-if="flixTheatreRangeDisplay"
            class="text-xs text-zinc-500 mt-0.5"
          >
            {{ flixTheatreRangeDisplay }}
          </p>
        </div>
        <button
          type="button"
          class="h-10 px-4 rounded-full text-sm font-semibold transition"
          :class="flixTheatreAdvancedMode
            ? 'bg-[#2D8CFF] text-white'
            : 'bg-zinc-100 text-zinc-800 hover:bg-zinc-200'"
          @click="flixTheatreAdvancedMode = !flixTheatreAdvancedMode"
        >
          {{ flixTheatreAdvancedMode ? 'Exit Advanced Mode' : 'Advanced Mode' }}
        </button>
      </div>

      <div class="rounded-xl border border-zinc-200 bg-white p-4">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Channel</span>
            <PlatformaSelect
              v-model="selectedFlixTheatreInstanceId"
              :options="flixTheatreSelectOptions"
            />
          </label>

          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Range</span>
            <PlatformaSelect
              v-model="flixTheatreRangeKey"
              :options="videoChannelRangeOptions"
            />
          </label>

          <label
            v-if="flixTheatreRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">From</span>
            <input
              v-model="flixTheatreCustomFrom"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>

          <label
            v-if="flixTheatreRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">To</span>
            <input
              v-model="flixTheatreCustomTo"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>

          <div class="flex items-end">
            <button
              type="button"
              class="h-10 w-full rounded-lg bg-zinc-100 hover:bg-zinc-200 text-sm font-semibold text-zinc-800"
              @click="loadFlixTheatreAnalytics"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="isLoadingFlixTheatreAnalytics"
        class="rounded-xl border border-zinc-200 bg-white px-4 py-10 flex items-center justify-center gap-3 text-zinc-600"
      >
        <span class="h-5 w-5 animate-spin rounded-full border-2 border-[#2D8CFF]/30 border-t-[#2D8CFF]" />
        <span class="text-sm font-medium">Loading flix theatre analytics...</span>
      </div>
      <div
        v-else-if="flixTheatreAnalyticsError"
        class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
      >
        {{ flixTheatreAnalyticsError }}
      </div>

      <template v-else>
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-6 gap-3">
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Views
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ flixTheatreTotals.views }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Impressions
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ flixTheatreTotals.impressions }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Watch Time (hours)
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatHours(flixTheatreTotals.watchTimeHours) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Avg View Duration
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatDuration(flixTheatreTotals.avgViewDurationSeconds) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Avg Percent Viewed
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatPercent(flixTheatreTotals.avgPercentViewed) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Top Viewers (members)
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ flixTheatreTopViewers.length }}
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Viewers - Members
            </div>
            <div
              v-if="!flixTheatreTopViewers.length"
              class="px-4 py-8 text-sm text-zinc-500"
            >
              No viewer activity yet for this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Member
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Impressions
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Watch Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="viewer in flixTheatreTopViewers"
                    :key="`flix-theatre-viewer-${viewer.memberId}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ viewer.memberName }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ viewer.views }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ viewer.impressions }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatHours(viewer.watchTimeHours) }}h
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Most Watched Videos
            </div>
            <div
              v-if="!flixTheatreTopVideos.length"
              class="px-4 py-8 text-sm text-zinc-500"
            >
              No video watch sessions recorded yet.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Video
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Watch Time
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Avg Duration
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Avg %
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="video in flixTheatreTopVideos"
                    :key="`flix-theatre-top-video-${video.videoId}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900 max-w-[340px] truncate">
                      {{ video.title }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ video.views }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatHours(video.watchTimeHours) }}h
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatDuration(video.avgViewDurationSeconds) }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatPercent(video.avgPercentViewed) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          v-if="flixTheatreAdvancedMode"
          class="grid grid-cols-1 xl:grid-cols-2 gap-4"
        >
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Reach Timeline
            </div>
            <div
              v-if="!flixTheatreTimeseries.length"
              class="px-4 py-8 text-sm text-zinc-500"
            >
              No timeline data for the selected range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Day
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Impressions
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Watch Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="point in flixTheatreTimeseries"
                    :key="`flix-theatre-day-${point.day}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-700">
                      {{ formatDate(point.day) }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ point.impressions }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ point.views }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatHours(point.watchTimeHours) }}h
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Channel Breakdown
            </div>
            <div
              v-if="!flixTheatreByChannel.length"
              class="px-4 py-8 text-sm text-zinc-500"
            >
              No channel-level data for the selected range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Channel
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Impressions
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Avg %
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in flixTheatreByChannel"
                    :key="`flix-theatre-breakdown-${row.featureInstanceId}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ row.channelTitle }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-800">
                      {{ row.views }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.impressions }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatPercent(row.avgPercentViewed) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div
      v-show="activeTab === 'stores'"
      class="pt-4 space-y-4"
    >
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 class="text-lg font-semibold text-zinc-900">
            Stores Analytics
          </h3>
          <p class="text-sm text-zinc-500 mt-0.5">
            {{ selectedStorefrontLabel }}
          </p>
          <p
            v-if="storefrontRangeDisplay"
            class="text-xs text-zinc-500 mt-0.5"
          >
            {{ storefrontRangeDisplay }}
          </p>
        </div>
      </div>

      <div class="rounded-xl border border-zinc-200 bg-white p-4">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Store</span>
            <PlatformaSelect
              v-model="selectedStorefrontInstanceId"
              :options="storefrontInstanceSelectOptions"
            />
          </label>
          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Range</span>
            <PlatformaSelect
              v-model="storefrontRangeKey"
              :options="storefrontRangeOptions"
            />
          </label>
          <label
            v-if="storefrontRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">From</span>
            <input
              v-model="storefrontCustomFrom"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>
          <label
            v-if="storefrontRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">To</span>
            <input
              v-model="storefrontCustomTo"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>
          <div class="flex items-end">
            <button
              type="button"
              class="h-10 w-full rounded-lg bg-zinc-100 hover:bg-zinc-200 text-sm font-semibold text-zinc-800"
              @click="loadStorefrontAnalytics"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="isLoadingStorefrontAnalytics"
        class="rounded-xl border border-zinc-200 bg-white px-4 py-10 flex items-center justify-center gap-3 text-zinc-600"
      >
        <span class="h-5 w-5 animate-spin rounded-full border-2 border-[#2D8CFF]/30 border-t-[#2D8CFF]" />
        <span class="text-sm font-medium">Loading storefront analytics...</span>
      </div>
      <div
        v-else-if="storefrontAnalyticsError"
        class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
      >
        {{ storefrontAnalyticsError }}
      </div>

      <template v-else>
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-6 gap-3">
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Gross Sales
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatUsdFromCents(storefrontSummary.grossSalesCents) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Orders
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ storefrontSummary.totalOrders }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Conversion Rate
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatStorePercent(storefrontSummary.conversionRatePercent) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Abandoned Checkout
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatStorePercent(storefrontSummary.abandonedCheckoutPercent) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Top Visitors
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ storefrontSummary.uniqueVisitors }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Avg Time On Store
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatStoreDuration(storefrontSummary.avgTimeOnStoreSeconds) }}
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Products Added To Cart
            </div>
            <div
              v-if="!topProductsAddedToCart.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No cart add activity yet.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Product
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Adds
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Members
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in topProductsAddedToCart"
                    :key="`store-added-${row.productId || row.productSlug || row.productTitle}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ row.productTitle }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.count }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.uniqueMembers }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Products Purchased
            </div>
            <div
              v-if="!topProductsPurchased.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No purchases in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Product
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Qty
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Sales
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in topProductsPurchased"
                    :key="`store-purchased-${row.productId || row.productTitle}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ row.productTitle }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.quantityCount }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatUsdFromCents(row.grossSalesCents) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Products Viewed
            </div>
            <div
              v-if="!topProductsViewed.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No product views in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Product
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Views
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Members
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in topProductsViewed"
                    :key="`store-viewed-${row.productId || row.productSlug || row.productTitle}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ row.productTitle }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.count }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.uniqueMembers }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Searched Items
            </div>
            <div
              v-if="!topSearchItems.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No search events in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Search
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Count
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Members
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in topSearchItems"
                    :key="`store-search-${row.query}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ row.query }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.count }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.uniqueMembers }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Members By Orders
            </div>
            <div
              v-if="!topMembersByOrderCount.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No order member data in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Member
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Orders
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Value
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in topMembersByOrderCount"
                    :key="`store-member-order-count-${row.memberUserId || row.email || row.displayName}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      <div class="font-medium">
                        {{ row.displayName }}
                      </div>
                      <div
                        v-if="row.email"
                        class="text-xs text-zinc-500 mt-0.5"
                      >
                        {{ row.email }}
                      </div>
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.orderCount }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatUsdFromCents(row.totalValueCents) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Members By Value
            </div>
            <div
              v-if="!topMembersByOrderValue.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No order value data in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Member
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Value
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Orders
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in topMembersByOrderValue"
                    :key="`store-member-order-value-${row.memberUserId || row.email || row.displayName}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      <div class="font-medium">
                        {{ row.displayName }}
                      </div>
                      <div
                        v-if="row.email"
                        class="text-xs text-zinc-500 mt-0.5"
                      >
                        {{ row.email }}
                      </div>
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatUsdFromCents(row.totalValueCents) }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.orderCount }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div
      v-show="activeTab === 'payment-analytics'"
      class="pt-4 space-y-4"
    >
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 class="text-lg font-semibold text-zinc-900">
            Payment Analytics
          </h3>
          <p class="text-sm text-zinc-500 mt-0.5">
            Feature paywall unlock purchases across your members
          </p>
          <p
            v-if="featurePaywallRangeDisplay"
            class="text-xs text-zinc-500 mt-0.5"
          >
            {{ featurePaywallRangeDisplay }}
          </p>
        </div>
      </div>

      <div class="rounded-xl border border-zinc-200 bg-white p-4">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Feature</span>
            <PlatformaSelect
              v-model="selectedFeaturePaywallInstanceId"
              :options="featurePaywallInstanceSelectOptions"
            />
          </label>
          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Range</span>
            <PlatformaSelect
              v-model="featurePaywallRangeKey"
              :options="featurePaywallRangeOptions"
            />
          </label>
          <label
            v-if="featurePaywallRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">From</span>
            <input
              v-model="featurePaywallCustomFrom"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>
          <label
            v-if="featurePaywallRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">To</span>
            <input
              v-model="featurePaywallCustomTo"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>
          <div class="flex items-end">
            <button
              type="button"
              class="h-10 w-full rounded-lg bg-zinc-100 hover:bg-zinc-200 text-sm font-semibold text-zinc-800"
              @click="loadFeaturePaywallAnalytics"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="isLoadingFeaturePaywallAnalytics"
        class="rounded-xl border border-zinc-200 bg-white px-4 py-10 flex items-center justify-center gap-3 text-zinc-600"
      >
        <span class="h-5 w-5 animate-spin rounded-full border-2 border-[#2D8CFF]/30 border-t-[#2D8CFF]" />
        <span class="text-sm font-medium">Loading payment analytics...</span>
      </div>
      <div
        v-else-if="featurePaywallAnalyticsError"
        class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
      >
        {{ featurePaywallAnalyticsError }}
      </div>

      <template v-else>
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Revenue
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatUsdFromCents(featurePaywallSummary.totalRevenueCents) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Unlocks
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ featurePaywallSummary.totalUnlocks }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Unique Members
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ featurePaywallSummary.uniqueMembers }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Avg Unlock Value
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatUsdFromCents(featurePaywallSummary.averageUnlockValueCents) }}
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Most Unlocked Features
            </div>
            <div
              v-if="!featurePaywallTopFeatures.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No feature unlock purchases in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Feature
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Unlocks
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Revenue
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in featurePaywallTopFeatures"
                    :key="`feature-paywall-feature-${row.featureInstanceId || row.featureSlug || row.featureName}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      <div class="font-medium">
                        {{ row.featureName || 'Feature' }}
                      </div>
                      <div
                        v-if="row.featureSlug"
                        class="text-xs text-zinc-500 mt-0.5"
                      >
                        {{ row.featureSlug }}
                      </div>
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.unlockCount }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatUsdFromCents(row.totalRevenueCents) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Members By Spend
            </div>
            <div
              v-if="!featurePaywallTopMembers.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No member spend data in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Member
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Unlocks
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Spent
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in featurePaywallTopMembers"
                    :key="`feature-paywall-member-${row.memberUserId || row.email || row.displayName}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      <div class="font-medium">
                        {{ row.displayName || 'Member' }}
                      </div>
                      <div
                        v-if="row.email"
                        class="text-xs text-zinc-500 mt-0.5"
                      >
                        {{ row.email }}
                      </div>
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.unlockCount }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatUsdFromCents(row.totalSpentCents) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
          <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
            Recent Feature Unlock Purchases
          </div>
          <div
            v-if="!featurePaywallRecentUnlocks.length"
            class="px-4 py-6 text-sm text-zinc-500"
          >
            No recent unlock purchases in this range.
          </div>
          <div
            v-else
            class="overflow-x-auto"
          >
            <table class="min-w-full text-sm">
              <thead class="bg-zinc-50 text-zinc-600">
                <tr>
                  <th class="text-left px-4 py-2 font-medium">
                    Member
                  </th>
                  <th class="text-left px-4 py-2 font-medium">
                    Feature
                  </th>
                  <th class="text-right px-4 py-2 font-medium">
                    Amount
                  </th>
                  <th class="text-right px-4 py-2 font-medium">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in featurePaywallRecentUnlocks"
                  :key="`feature-paywall-recent-${row.id || row.paymentPublicId || `${row.memberUserId}-${row.featureInstanceId}-${row.occurredAt}`}`"
                  class="border-t border-zinc-100"
                >
                  <td class="px-4 py-2 text-zinc-900">
                    <div class="font-medium">
                      {{ row.memberName || 'Member' }}
                    </div>
                    <div
                      v-if="row.memberEmail"
                      class="text-xs text-zinc-500 mt-0.5"
                    >
                      {{ row.memberEmail }}
                    </div>
                  </td>
                  <td class="px-4 py-2 text-zinc-700">
                    <div class="font-medium text-zinc-900">
                      {{ row.featureName || 'Feature Unlock' }}
                    </div>
                    <div
                      v-if="row.featureSlug"
                      class="text-xs text-zinc-500 mt-0.5"
                    >
                      {{ row.featureSlug }}
                    </div>
                  </td>
                  <td class="px-4 py-2 text-right text-zinc-700">
                    {{ formatUsdFromCents(row.amountCents) }}
                  </td>
                  <td class="px-4 py-2 text-right text-zinc-700">
                    {{ formatDateTime(row.occurredAt) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </div>

    <div
      v-show="activeTab === 'crypto'"
      class="pt-4 space-y-4"
    >
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 class="text-lg font-semibold text-zinc-900">
            Crypto Analytics
          </h3>
          <p class="text-sm text-zinc-500 mt-0.5">
            Member wallet activity and usage overview
          </p>
          <p
            v-if="cryptoRangeDisplay"
            class="text-xs text-zinc-500 mt-0.5"
          >
            {{ cryptoRangeDisplay }}
          </p>
        </div>
      </div>

      <div class="rounded-xl border border-zinc-200 bg-white p-4">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
          <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">Range</span>
            <PlatformaSelect
              v-model="cryptoRangeKey"
              :options="cryptoRangeOptions"
            />
          </label>
          <label
            v-if="cryptoRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">From</span>
            <input
              v-model="cryptoCustomFrom"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>
          <label
            v-if="cryptoRangeKey === 'custom'"
            class="flex flex-col gap-1"
          >
            <span class="text-xs font-semibold uppercase tracking-wide text-zinc-500">To</span>
            <input
              v-model="cryptoCustomTo"
              type="date"
              class="h-10 rounded-lg border border-zinc-300 bg-white px-3 text-sm text-zinc-800 focus:outline-none focus:ring-2 focus:ring-[#2D8CFF]/40"
            >
          </label>
          <div class="flex items-end">
            <button
              type="button"
              class="h-10 w-full rounded-lg bg-zinc-100 hover:bg-zinc-200 text-sm font-semibold text-zinc-800"
              @click="loadCryptoAnalytics"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="isLoadingCryptoAnalytics"
        class="rounded-xl border border-zinc-200 bg-white px-4 py-10 flex items-center justify-center gap-3 text-zinc-600"
      >
        <span class="h-5 w-5 animate-spin rounded-full border-2 border-[#2D8CFF]/30 border-t-[#2D8CFF]" />
        <span class="text-sm font-medium">Loading crypto analytics...</span>
      </div>
      <div
        v-else-if="cryptoAnalyticsError"
        class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
      >
        {{ cryptoAnalyticsError }}
      </div>

      <template v-else>
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Members With Wallet
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ cryptoSummary.walletActivatedMembers }} / {{ cryptoSummary.totalMembers }}
            </p>
            <p class="mt-1 text-xs text-zinc-500">
              {{ formatStorePercent(cryptoSummary.walletActivatedPercent) }} activated
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Members Used Buy
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ cryptoSummary.membersUsedBuyCount }}
            </p>
            <p class="mt-1 text-xs text-zinc-500">
              {{ formatStorePercent(cryptoSummary.membersUsedBuyPercent) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Members Used Send
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ cryptoSummary.membersUsedSendCount }}
            </p>
            <p class="mt-1 text-xs text-zinc-500">
              {{ formatStorePercent(cryptoSummary.membersUsedSendPercent) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Members Used Sell
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ cryptoSummary.membersUsedSellCount }}
            </p>
            <p class="mt-1 text-xs text-zinc-500">
              {{ formatStorePercent(cryptoSummary.membersUsedSellPercent) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Members Connected Bank
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ cryptoSummary.membersUsedBankConnectCount }}
            </p>
            <p class="mt-1 text-xs text-zinc-500">
              {{ formatStorePercent(cryptoSummary.membersUsedBankConnectPercent) }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Events
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ cryptoSummary.totalEvents }}
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              BTC Moved
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatBtcAmount(cryptoSummary.totalMovedBtc) }}
            </p>
            <p class="mt-1 text-xs text-zinc-500">
              {{ cryptoSummary.totalMovedSats.toLocaleString() }} sats
            </p>
          </div>
          <div class="rounded-xl border border-zinc-200 bg-white p-4">
            <p class="text-xs uppercase tracking-wide text-zinc-500">
              Approx USD Moved
            </p>
            <p class="text-2xl font-semibold text-zinc-900 mt-1">
              {{ formatUsdFromCents(Math.round((cryptoSummary.totalMovedUsdApprox || 0) * 100)) }}
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Users By Wallet Activity
            </div>
            <div
              v-if="!cryptoTopUsers.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No crypto activity in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Member
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Events
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      BTC Moved
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Buy / Sell / Send
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in cryptoTopUsers"
                    :key="`crypto-top-${row.memberUserId || row.email || row.displayName}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      <div class="font-medium">
                        {{ row.displayName }}
                      </div>
                      <div
                        v-if="row.email"
                        class="text-xs text-zinc-500 mt-0.5"
                      >
                        {{ row.email }}
                      </div>
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.eventCount }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ formatBtcAmount(row.movedBtc) }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.buyCount }} / {{ row.sellCount }} / {{ row.sendCount }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="rounded-xl border border-zinc-200 bg-white overflow-hidden">
            <div class="px-4 py-3 border-b border-zinc-200 text-sm font-semibold text-zinc-800">
              Top Crypto Actions
            </div>
            <div
              v-if="!cryptoTopActions.length"
              class="px-4 py-6 text-sm text-zinc-500"
            >
              No action data recorded in this range.
            </div>
            <div
              v-else
              class="overflow-x-auto"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-zinc-50 text-zinc-600">
                  <tr>
                    <th class="text-left px-4 py-2 font-medium">
                      Action
                    </th>
                    <th class="text-right px-4 py-2 font-medium">
                      Count
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in cryptoTopActions"
                    :key="`crypto-action-${row.action}`"
                    class="border-t border-zinc-100"
                  >
                    <td class="px-4 py-2 text-zinc-900">
                      {{ row.action }}
                    </td>
                    <td class="px-4 py-2 text-right text-zinc-700">
                      {{ row.count }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {
  addLocalWorldBasemap,
  addSelfHostedStreetBasemap,
} from '@/utils/localWorldBasemap';
import { usePresenceStore } from '@/stores/presenceStore';
import { useWebsocketStore } from '@/stores/websocketStore';
import CreatorAnalyticsNewsfeedViewers from '@/Components/CreatorAnalyticsNewsfeedViewers.vue';
import CreatorBroadcastAnalytics from '@/Components/CreatorBroadcastAnalytics.vue';
import CreatorCourseCertificateViewerModal from '@/Components/CreatorCourseCertificateViewerModal.vue';
import CreatorMemberActivityStream from '@/Components/CreatorMemberActivityStream.vue';
import CreatorPodcastAnalytics from '@/Components/CreatorPodcastAnalytics.vue';
import CreatorQuizAnalytics from '@/Components/CreatorQuizAnalytics.vue';
import CreatorWebinarAnalytics from '@/Components/CreatorWebinarAnalytics.vue';
import PlatformaSelect from '@/Components/PlatformaSelect.vue';
import {
  fetchMembersAnalytics,
  fetchCryptoAnalytics,
  fetchCourseProgressOverview,
  fetchFeaturePaywallAnalytics,
  fetchFlixTheatreAnalytics,
  fetchStorefrontAnalytics,
  fetchVideoChannelAnalytics,
} from '@/services/creatorEngagementService';

const apiProxyUrl = process.env.VUE_APP_API_PROXY_URL;
const apiBackendUrl = process.env.VUE_APP_PLATFORMA_API_BACKEND_URL;
const router = useRouter();
const presenceStore = usePresenceStore();
const websocketStore = useWebsocketStore();

const activeTab = ref('overview');

const membersRangeOptions = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '365d', label: 'Last 365 days' },
  { value: 'lifetime', label: 'Lifetime' },
  { value: 'custom', label: 'Custom' },
];

const createEmptyMembersAnalytics = () => ({
  scope: {
    creatorUserId: 0,
    rangeKey: '30d',
    from: null,
    to: null,
  },
  summary: {
    leadsCreatedCount: 0,
    membersAddedCount: 0,
    membersLostCount: 0,
    onSubscriptionCount: 0,
    subscriptionsStartedCount: 0,
    subscriptionsChangedCount: 0,
    subscriptionsCanceledCount: 0,
    paymentsSucceededCount: 0,
    paymentsFailedCount: 0,
  },
  bars: [
    { key: 'members_added', label: 'Members Added', count: 0 },
    { key: 'members_lost', label: 'Members Lost', count: 0 },
    { key: 'on_subscription', label: 'On Subscription', count: 0 },
    { key: 'payment_failed', label: 'Payment Failed', count: 0 },
    { key: 'subscription_canceled', label: 'Canceled', count: 0 },
  ],
});

const membersRangeKey = ref('30d');
const membersCustomFrom = ref('');
const membersCustomTo = ref('');
const isLoadingMembersAnalytics = ref(false);
const membersAnalyticsError = ref('');
const membersAnalytics = ref(createEmptyMembersAnalytics());

const membersSummary = computed(() => {
  const summary = membersAnalytics.value?.summary || {};
  return {
    leadsCreatedCount: Number(summary?.leadsCreatedCount || 0),
    membersAddedCount: Number(summary?.membersAddedCount || 0),
    membersLostCount: Number(summary?.membersLostCount || 0),
    onSubscriptionCount: Number(summary?.onSubscriptionCount || 0),
    subscriptionsStartedCount: Number(summary?.subscriptionsStartedCount || 0),
    subscriptionsChangedCount: Number(summary?.subscriptionsChangedCount || 0),
    subscriptionsCanceledCount: Number(summary?.subscriptionsCanceledCount || 0),
    paymentsSucceededCount: Number(summary?.paymentsSucceededCount || 0),
    paymentsFailedCount: Number(summary?.paymentsFailedCount || 0),
  };
});

const membersBars = computed(() => (
  Array.isArray(membersAnalytics.value?.bars)
    ? membersAnalytics.value.bars.map((row) => ({
      key: String(row?.key || '').trim(),
      label: String(row?.label || '').trim() || 'Metric',
      count: Number(row?.count || 0),
    })).filter((row) => row.key)
    : []
));

const membersBarMaxCount = computed(() => {
  const maxValue = membersBars.value.reduce((max, row) => Math.max(max, Number(row?.count || 0)), 0);
  return Math.max(1, maxValue);
});

const emptyOverviewSummaryWindow = () => ({
  totalUsers: 0,
  desktopUsers: 0,
  mobileUsers: 0,
  otherUsers: 0,
});
const createEmptyOverviewSummary = () => ({
  last30: emptyOverviewSummaryWindow(),
  live: emptyOverviewSummaryWindow(),
});

const overviewWindow = ref('last30');
const overviewMembersByWindow = ref({
  last30: [],
  live: [],
});
const overviewSummary = ref(createEmptyOverviewSummary());
const isLoadingOverviewMap = ref(false);
const overviewMapError = ref('');

const selectedOverviewSummary = computed(() => {
  const key = overviewWindow.value === 'live' ? 'live' : 'last30';
  return overviewSummary.value?.[key] || emptyOverviewSummaryWindow();
});
const totalUsers = computed(() => Number(selectedOverviewSummary.value.totalUsers || 0));
const desktopUsers = computed(() => Number(selectedOverviewSummary.value.desktopUsers || 0));
const mobileUsers = computed(() => Number(selectedOverviewSummary.value.mobileUsers || 0));
const overviewWindowTitle = computed(() => (
  overviewWindow.value === 'live'
    ? 'Current Live Users'
    : 'Last 30 min. Users'
));
const overviewWindowDeviceTitle = computed(() => (
  overviewWindow.value === 'live'
    ? 'Device Category (Current Live)'
    : 'Device Category in Last 30 Minutes'
));
const desktopPercentage = computed(() => {
  if (!totalUsers.value) return '0.0';
  return ((desktopUsers.value / totalUsers.value) * 100).toFixed(1);
});
const mobilePercentage = computed(() => {
  if (!totalUsers.value) return '0.0';
  return ((mobileUsers.value / totalUsers.value) * 100).toFixed(1);
});

let map = null;
let markersLayer = null;
let mapAutoFitDone = false;
let isRenderingOverviewMarkers = false;
let overviewMapRefreshTimer = null;
let lastPresenceDrivenOverviewRefreshAt = 0;
const mapReady = ref(false);

const newsfeedInstances = ref([]);
const selectedInstanceId = ref(null);
const newsfeedSelectOptions = computed(() => (
  newsfeedInstances.value.map((nf) => ({
    value: Number(nf.id || 0),
    label: String(nf.name || `Newsfeed ${nf.id || ''}`),
  })).filter((row) => row.value > 0)
));

const isLoadingAnalytics = ref(false);
const analyticsError = ref('');
const analyticsTotals = ref({
  totalViews: 0,
  feedViews: 0,
  slugViews: 0,
  uniqueViewers: 0,
  viewedPosts: 0,
});
const analyticsPosts = ref([]);

const selectedViewerPostId = ref(null);
const isViewersModalOpen = ref(false);
const isLoadingViewers = ref(false);
const viewersError = ref('');
const viewerRows = ref([]);
const includeCreatorViews = ref(false);
const courseInstances = ref([]);
const selectedCourseInstanceId = ref('');
const courseSelectOptions = computed(() => ([
  { value: '', label: 'All Courses' },
  ...courseInstances.value.map((course) => ({
    value: Number(course.id || 0),
    label: String(course.name || `Course ${course.id || ''}`),
  })).filter((row) => row.value > 0),
]));
const courseMemberSearch = ref('');
const isLoadingCourseProgress = ref(false);
const courseProgressError = ref('');
const courseProgressRows = ref([]);
const courseProgressTotals = ref({
  enrolledMembers: 0,
  startedMembers: 0,
  completedMembers: 0,
  avgCompletionPercent: 0,
  certificatesGenerated: 0,
});
const certificateViewerOpen = ref(false);
const certificateViewerPdfSrc = ref('');
const certificateViewerDownloadUrl = ref('');

const videoChannelRangeOptions = [
  { value: '7d', label: 'Last 7 days' },
  { value: '28d', label: 'Last 28 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '365d', label: 'Last 365 days' },
  { value: 'lifetime', label: 'Lifetime' },
  { value: 'custom', label: 'Custom' },
];

function emptyVideoChannelAnalytics() {
  return {
    scope: {
      creatorId: 0,
      featureInstanceId: null,
      rangeKey: '28d',
      from: null,
      to: null,
    },
    channels: [],
    totals: {
      impressions: 0,
      views: 0,
      uniqueViewers: 0,
      watchTimeSeconds: 0,
      watchTimeHours: 0,
      avgViewDurationSeconds: 0,
      avgPercentViewed: 0,
    },
    topViewers: [],
    mostWatchedVideos: [],
    byChannel: [],
    timeseries: [],
  };
}

const selectedVideoChannelInstanceId = ref('all');
const videoChannelRangeKey = ref('28d');
const videoChannelCustomFrom = ref('');
const videoChannelCustomTo = ref('');
const videoChannelAdvancedMode = ref(false);
const isLoadingVideoChannelAnalytics = ref(false);
const videoChannelAnalyticsError = ref('');
const videoChannelAnalytics = ref(emptyVideoChannelAnalytics());

const videoChannelOptions = computed(() => {
  const rows = Array.isArray(videoChannelAnalytics.value?.channels)
    ? videoChannelAnalytics.value.channels
    : [];
  return rows
    .map((row) => ({
      featureInstanceId: Number(row?.featureInstanceId || 0) || 0,
      channelTitle: String(row?.channelTitle || '').trim() || 'Video Channel',
    }))
    .filter((row) => row.featureInstanceId > 0);
});
const videoChannelSelectOptions = computed(() => ([
  { value: 'all', label: 'All Video Channels' },
  ...videoChannelOptions.value.map((channel) => ({
    value: String(channel.featureInstanceId),
    label: channel.channelTitle,
  })),
]));

const selectedVideoChannelLabel = computed(() => {
  if (selectedVideoChannelInstanceId.value === 'all') return 'Overview across all video channels';
  const targetId = Number(selectedVideoChannelInstanceId.value || 0) || 0;
  const row = videoChannelOptions.value.find((item) => item.featureInstanceId === targetId);
  return row?.channelTitle || 'Video Channel';
});

const videoChannelRangeDisplay = computed(() => {
  const scope = videoChannelAnalytics.value?.scope || {};
  const fromRaw = scope?.from || '';
  const toRaw = scope?.to || '';
  if (!fromRaw && !toRaw) return '';

  const parseLocalDate = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const fromLabel = fromRaw ? parseLocalDate(fromRaw) : 'Start';
  const toLabel = toRaw ? parseLocalDate(toRaw) : 'Now';
  return `${fromLabel} - ${toLabel}`;
});

const videoChannelTotals = computed(() => {
  const raw = videoChannelAnalytics.value?.totals || {};
  return {
    impressions: Number(raw.impressions || 0) || 0,
    views: Number(raw.views || 0) || 0,
    uniqueViewers: Number(raw.uniqueViewers || 0) || 0,
    watchTimeSeconds: Number(raw.watchTimeSeconds || 0) || 0,
    watchTimeHours: Number(raw.watchTimeHours || 0) || 0,
    avgViewDurationSeconds: Number(raw.avgViewDurationSeconds || 0) || 0,
    avgPercentViewed: Number(raw.avgPercentViewed || 0) || 0,
  };
});

const videoChannelTopViewers = computed(() => (
  Array.isArray(videoChannelAnalytics.value?.topViewers)
    ? videoChannelAnalytics.value.topViewers
    : []
));
const videoChannelTopVideos = computed(() => (
  Array.isArray(videoChannelAnalytics.value?.mostWatchedVideos)
    ? videoChannelAnalytics.value.mostWatchedVideos
    : []
));
const videoChannelByChannel = computed(() => (
  Array.isArray(videoChannelAnalytics.value?.byChannel)
    ? videoChannelAnalytics.value.byChannel
    : []
));
const videoChannelTimeseries = computed(() => (
  Array.isArray(videoChannelAnalytics.value?.timeseries)
    ? videoChannelAnalytics.value.timeseries
    : []
));

const selectedFlixTheatreInstanceId = ref('all');
const flixTheatreRangeKey = ref('28d');
const flixTheatreCustomFrom = ref('');
const flixTheatreCustomTo = ref('');
const flixTheatreAdvancedMode = ref(false);
const isLoadingFlixTheatreAnalytics = ref(false);
const flixTheatreAnalyticsError = ref('');
const flixTheatreAnalytics = ref(emptyVideoChannelAnalytics());

const flixTheatreOptions = computed(() => {
  const rows = Array.isArray(flixTheatreAnalytics.value?.channels)
    ? flixTheatreAnalytics.value.channels
    : [];
  return rows
    .map((row) => ({
      featureInstanceId: Number(row?.featureInstanceId || 0) || 0,
      channelTitle: String(row?.channelTitle || '').trim() || 'Flix Theatre',
    }))
    .filter((row) => row.featureInstanceId > 0);
});
const flixTheatreSelectOptions = computed(() => ([
  { value: 'all', label: 'All Flix Theatres' },
  ...flixTheatreOptions.value.map((channel) => ({
    value: String(channel.featureInstanceId),
    label: channel.channelTitle,
  })),
]));

const selectedFlixTheatreLabel = computed(() => {
  if (selectedFlixTheatreInstanceId.value === 'all') return 'Overview across all flix theatres';
  const targetId = Number(selectedFlixTheatreInstanceId.value || 0) || 0;
  const row = flixTheatreOptions.value.find((item) => item.featureInstanceId === targetId);
  return row?.channelTitle || 'Flix Theatre';
});

const flixTheatreRangeDisplay = computed(() => {
  const scope = flixTheatreAnalytics.value?.scope || {};
  const fromRaw = scope?.from || '';
  const toRaw = scope?.to || '';
  if (!fromRaw && !toRaw) return '';

  const parseLocalDate = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const fromLabel = fromRaw ? parseLocalDate(fromRaw) : 'Start';
  const toLabel = toRaw ? parseLocalDate(toRaw) : 'Now';
  return `${fromLabel} - ${toLabel}`;
});

const flixTheatreTotals = computed(() => {
  const raw = flixTheatreAnalytics.value?.totals || {};
  return {
    impressions: Number(raw.impressions || 0) || 0,
    views: Number(raw.views || 0) || 0,
    uniqueViewers: Number(raw.uniqueViewers || 0) || 0,
    watchTimeSeconds: Number(raw.watchTimeSeconds || 0) || 0,
    watchTimeHours: Number(raw.watchTimeHours || 0) || 0,
    avgViewDurationSeconds: Number(raw.avgViewDurationSeconds || 0) || 0,
    avgPercentViewed: Number(raw.avgPercentViewed || 0) || 0,
  };
});

const flixTheatreTopViewers = computed(() => (
  Array.isArray(flixTheatreAnalytics.value?.topViewers)
    ? flixTheatreAnalytics.value.topViewers
    : []
));
const flixTheatreTopVideos = computed(() => (
  Array.isArray(flixTheatreAnalytics.value?.mostWatchedVideos)
    ? flixTheatreAnalytics.value.mostWatchedVideos
    : []
));
const flixTheatreByChannel = computed(() => (
  Array.isArray(flixTheatreAnalytics.value?.byChannel)
    ? flixTheatreAnalytics.value.byChannel
    : []
));
const flixTheatreTimeseries = computed(() => (
  Array.isArray(flixTheatreAnalytics.value?.timeseries)
    ? flixTheatreAnalytics.value.timeseries
    : []
));

const storefrontRangeOptions = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '365d', label: 'Last 365 days' },
  { value: 'lifetime', label: 'Lifetime' },
  { value: 'custom', label: 'Custom' },
];

const createEmptyStorefrontAnalytics = () => ({
  scope: {
    creatorUserId: 0,
    featureInstanceId: null,
    rangeKey: '30d',
    from: null,
    to: null,
  },
  instances: [],
  summary: {
    grossSalesCents: 0,
    totalOrders: 0,
    uniqueVisitors: 0,
    uniquePurchasers: 0,
    conversionRatePercent: 0,
    checkoutStartedCount: 0,
    abandonedCheckoutCount: 0,
    abandonedCheckoutPercent: 0,
    avgTimeOnStoreSeconds: 0,
    totalTimeOnStoreSeconds: 0,
  },
  topProductsAddedToCart: [],
  topProductsPurchased: [],
  topProductsViewed: [],
  topMembersByOrderCount: [],
  topMembersByOrderValue: [],
  topSearchItems: [],
});

const selectedStorefrontInstanceId = ref('all');
const storefrontRangeKey = ref('30d');
const storefrontCustomFrom = ref('');
const storefrontCustomTo = ref('');
const isLoadingStorefrontAnalytics = ref(false);
const storefrontAnalyticsError = ref('');
const storefrontAnalytics = ref(createEmptyStorefrontAnalytics());

const storefrontInstanceSelectOptions = computed(() => ([
  { value: 'all', label: 'All Stores' },
  ...((Array.isArray(storefrontAnalytics.value?.instances) ? storefrontAnalytics.value.instances : [])
    .map((row) => ({
      value: String(row?.featureInstanceId || ''),
      label: String(row?.instanceName || row?.featureSlug || `Store ${row?.featureInstanceId || ''}`).trim(),
    }))
    .filter((row) => row.value)),
]));

const selectedStorefrontLabel = computed(() => {
  if (selectedStorefrontInstanceId.value === 'all') return 'Overview across all storefront instances';
  const hit = storefrontInstanceSelectOptions.value.find(
    (row) => String(row.value) === String(selectedStorefrontInstanceId.value || '')
  );
  return hit?.label || 'Storefront instance';
});

const storefrontRangeDisplay = computed(() => {
  const scope = storefrontAnalytics.value?.scope || {};
  const fromRaw = scope?.from || '';
  const toRaw = scope?.to || '';
  if (!fromRaw && !toRaw) return '';
  const parseLocalDate = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  };
  const fromLabel = fromRaw ? parseLocalDate(fromRaw) : 'Start';
  const toLabel = toRaw ? parseLocalDate(toRaw) : 'Now';
  return `${fromLabel} - ${toLabel}`;
});

const storefrontSummary = computed(() => {
  const summary = storefrontAnalytics.value?.summary || {};
  return {
    grossSalesCents: Number(summary?.grossSalesCents || 0),
    totalOrders: Number(summary?.totalOrders || 0),
    uniqueVisitors: Number(summary?.uniqueVisitors || 0),
    uniquePurchasers: Number(summary?.uniquePurchasers || 0),
    conversionRatePercent: Number(summary?.conversionRatePercent || 0),
    checkoutStartedCount: Number(summary?.checkoutStartedCount || 0),
    abandonedCheckoutCount: Number(summary?.abandonedCheckoutCount || 0),
    abandonedCheckoutPercent: Number(summary?.abandonedCheckoutPercent || 0),
    avgTimeOnStoreSeconds: Number(summary?.avgTimeOnStoreSeconds || 0),
    totalTimeOnStoreSeconds: Number(summary?.totalTimeOnStoreSeconds || 0),
  };
});

const topProductsAddedToCart = computed(() => (
  Array.isArray(storefrontAnalytics.value?.topProductsAddedToCart)
    ? storefrontAnalytics.value.topProductsAddedToCart
    : []
));
const topProductsPurchased = computed(() => (
  Array.isArray(storefrontAnalytics.value?.topProductsPurchased)
    ? storefrontAnalytics.value.topProductsPurchased
    : []
));
const topProductsViewed = computed(() => (
  Array.isArray(storefrontAnalytics.value?.topProductsViewed)
    ? storefrontAnalytics.value.topProductsViewed
    : []
));
const topMembersByOrderCount = computed(() => (
  Array.isArray(storefrontAnalytics.value?.topMembersByOrderCount)
    ? storefrontAnalytics.value.topMembersByOrderCount
    : []
));
const topMembersByOrderValue = computed(() => (
  Array.isArray(storefrontAnalytics.value?.topMembersByOrderValue)
    ? storefrontAnalytics.value.topMembersByOrderValue
    : []
));
const topSearchItems = computed(() => (
  Array.isArray(storefrontAnalytics.value?.topSearchItems)
    ? storefrontAnalytics.value.topSearchItems
    : []
));

const featurePaywallRangeOptions = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '365d', label: 'Last 365 days' },
  { value: 'lifetime', label: 'Lifetime' },
  { value: 'custom', label: 'Custom' },
];

const createEmptyFeaturePaywallAnalytics = () => ({
  scope: {
    creatorUserId: 0,
    featureInstanceId: null,
    rangeKey: '30d',
    from: null,
    to: null,
  },
  instances: [],
  summary: {
    totalUnlocks: 0,
    totalRevenueCents: 0,
    uniqueMembers: 0,
    averageUnlockValueCents: 0,
  },
  topFeatures: [],
  topMembers: [],
  recentUnlocks: [],
});

const selectedFeaturePaywallInstanceId = ref('all');
const featurePaywallRangeKey = ref('30d');
const featurePaywallCustomFrom = ref('');
const featurePaywallCustomTo = ref('');
const isLoadingFeaturePaywallAnalytics = ref(false);
const featurePaywallAnalyticsError = ref('');
const featurePaywallAnalytics = ref(createEmptyFeaturePaywallAnalytics());

const featurePaywallInstanceSelectOptions = computed(() => ([
  { value: 'all', label: 'All Paywalled Features' },
  ...((Array.isArray(featurePaywallAnalytics.value?.instances) ? featurePaywallAnalytics.value.instances : [])
    .map((row) => ({
      value: String(row?.featureInstanceId || ''),
      label: String(row?.featureName || row?.featureSlug || `Feature ${row?.featureInstanceId || ''}`).trim(),
    }))
    .filter((row) => row.value)),
]));

const featurePaywallRangeDisplay = computed(() => {
  const scope = featurePaywallAnalytics.value?.scope || {};
  const fromRaw = scope?.from || '';
  const toRaw = scope?.to || '';
  if (!fromRaw && !toRaw) return '';

  const parseLocalDate = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const fromLabel = fromRaw ? parseLocalDate(fromRaw) : 'Start';
  const toLabel = toRaw ? parseLocalDate(toRaw) : 'Now';
  return `${fromLabel} - ${toLabel}`;
});

const featurePaywallSummary = computed(() => {
  const summary = featurePaywallAnalytics.value?.summary || {};
  return {
    totalUnlocks: Number(summary?.totalUnlocks || 0),
    totalRevenueCents: Number(summary?.totalRevenueCents || 0),
    uniqueMembers: Number(summary?.uniqueMembers || 0),
    averageUnlockValueCents: Number(summary?.averageUnlockValueCents || 0),
  };
});

const featurePaywallTopFeatures = computed(() => (
  Array.isArray(featurePaywallAnalytics.value?.topFeatures)
    ? featurePaywallAnalytics.value.topFeatures
    : []
));
const featurePaywallTopMembers = computed(() => (
  Array.isArray(featurePaywallAnalytics.value?.topMembers)
    ? featurePaywallAnalytics.value.topMembers
    : []
));
const featurePaywallRecentUnlocks = computed(() => (
  Array.isArray(featurePaywallAnalytics.value?.recentUnlocks)
    ? featurePaywallAnalytics.value.recentUnlocks
    : []
));

const cryptoRangeOptions = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '365d', label: 'Last 365 days' },
  { value: 'lifetime', label: 'Lifetime' },
  { value: 'custom', label: 'Custom' },
];

const createEmptyCryptoAnalytics = () => ({
  scope: {
    creatorUserId: 0,
    rangeKey: '30d',
    from: null,
    to: null,
  },
  summary: {
    totalMembers: 0,
    walletActivatedMembers: 0,
    walletNotActivatedMembers: 0,
    walletActivatedPercent: 0,
    walletNotActivatedPercent: 0,
    membersUsedBuyCount: 0,
    membersUsedBuyPercent: 0,
    membersUsedSendCount: 0,
    membersUsedSendPercent: 0,
    membersUsedSellCount: 0,
    membersUsedSellPercent: 0,
    membersUsedBankConnectCount: 0,
    membersUsedBankConnectPercent: 0,
    totalEvents: 0,
    totalMovedSats: 0,
    totalMovedBtc: 0,
    totalMovedUsdApprox: 0,
  },
  topUsers: [],
  topActions: [],
});

const cryptoRangeKey = ref('30d');
const cryptoCustomFrom = ref('');
const cryptoCustomTo = ref('');
const isLoadingCryptoAnalytics = ref(false);
const cryptoAnalyticsError = ref('');
const cryptoAnalytics = ref(createEmptyCryptoAnalytics());

const cryptoRangeDisplay = computed(() => {
  const scope = cryptoAnalytics.value?.scope || {};
  const fromRaw = scope?.from || '';
  const toRaw = scope?.to || '';
  if (!fromRaw && !toRaw) return '';
  const parseLocalDate = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  };
  const fromLabel = fromRaw ? parseLocalDate(fromRaw) : 'Start';
  const toLabel = toRaw ? parseLocalDate(toRaw) : 'Now';
  return `${fromLabel} - ${toLabel}`;
});

const cryptoSummary = computed(() => {
  const summary = cryptoAnalytics.value?.summary || {};
  return {
    totalMembers: Number(summary?.totalMembers || 0),
    walletActivatedMembers: Number(summary?.walletActivatedMembers || 0),
    walletNotActivatedMembers: Number(summary?.walletNotActivatedMembers || 0),
    walletActivatedPercent: Number(summary?.walletActivatedPercent || 0),
    walletNotActivatedPercent: Number(summary?.walletNotActivatedPercent || 0),
    membersUsedBuyCount: Number(summary?.membersUsedBuyCount || 0),
    membersUsedBuyPercent: Number(summary?.membersUsedBuyPercent || 0),
    membersUsedSendCount: Number(summary?.membersUsedSendCount || 0),
    membersUsedSendPercent: Number(summary?.membersUsedSendPercent || 0),
    membersUsedSellCount: Number(summary?.membersUsedSellCount || 0),
    membersUsedSellPercent: Number(summary?.membersUsedSellPercent || 0),
    membersUsedBankConnectCount: Number(summary?.membersUsedBankConnectCount || 0),
    membersUsedBankConnectPercent: Number(summary?.membersUsedBankConnectPercent || 0),
    totalEvents: Number(summary?.totalEvents || 0),
    totalMovedSats: Number(summary?.totalMovedSats || 0),
    totalMovedBtc: Number(summary?.totalMovedBtc || 0),
    totalMovedUsdApprox: Number(summary?.totalMovedUsdApprox || 0),
  };
});

const cryptoTopUsers = computed(() => (
  Array.isArray(cryptoAnalytics.value?.topUsers)
    ? cryptoAnalytics.value.topUsers
    : []
));
const cryptoTopActions = computed(() => (
  Array.isArray(cryptoAnalytics.value?.topActions)
    ? cryptoAnalytics.value.topActions
    : []
));

function formatDateTime(v) {
  if (!v) return '-';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString();
}

function formatDate(v) {
  if (!v) return '-';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString();
}

function formatHours(value) {
  const numeric = Number(value || 0);
  if (!Number.isFinite(numeric)) return '0.00';
  return numeric.toFixed(2);
}

function formatDuration(seconds) {
  const safe = Math.max(0, Math.floor(Number(seconds || 0)));
  const hrs = Math.floor(safe / 3600);
  const mins = Math.floor((safe % 3600) / 60);
  const secs = safe % 60;
  if (hrs > 0) {
    return `${hrs}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  return `${mins}:${String(secs).padStart(2, '0')}`;
}

function formatPercent(value) {
  const numeric = Number(value || 0);
  if (!Number.isFinite(numeric) || numeric <= 0) return '0.0%';
  return `${numeric.toFixed(1)}%`;
}

function formatUsdFromCents(value) {
  const cents = Number(value || 0);
  const dollars = Number.isFinite(cents) ? cents / 100 : 0;
  return dollars.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatStorePercent(value) {
  const numeric = Number(value || 0);
  if (!Number.isFinite(numeric) || numeric <= 0) return '0.0%';
  return `${numeric.toFixed(1)}%`;
}

function formatStoreDuration(valueSeconds) {
  const totalSeconds = Math.max(0, Math.floor(Number(valueSeconds || 0)));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds}s`;
}

function formatBtcAmount(value) {
  const numeric = Number(value || 0);
  if (!Number.isFinite(numeric) || numeric <= 0) return '0.00000000 BTC';
  return `${numeric.toFixed(8)} BTC`;
}

function openPostBySlug(slug) {
  const safeSlug = String(slug || '').trim();
  if (!safeSlug) return;

  const target = router.resolve({
    name: 'NewsfeedPostSlug',
    params: { postSlug: safeSlug },
  });

  window.open(target.href, '_blank', 'noopener,noreferrer');
}

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function sanitizeImageUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) || /^data:image\//i.test(raw) || raw.startsWith('/')) {
    return raw;
  }
  return '';
}

function initialsFor(text) {
  const normalized = String(text || '').trim();
  if (!normalized) return 'U';
  const parts = normalized.split(/\s+/).filter(Boolean);
  const initials = parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('');
  return initials || 'U';
}

function parsePayload(response) {
  const contentType = String(response.headers.get('content-type') || '').toLowerCase();
  if (contentType.includes('application/json')) {
    return response.json().catch(() => ({}));
  }
  return response.text().then((text) => ({ __rawText: text })).catch(() => ({}));
}

function normalizeOverviewMembers(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => {
      const userType = String(row?.userType || 'member').trim().toLowerCase() || 'member';
      const userId = Number(
        row?.userId
        || row?.actorUserId
        || (userType === 'member' ? row?.memberUserId : 0)
        || (userType === 'creator_staff' ? row?.staffUserId : 0)
      );
      if (!Number.isFinite(userId) || userId <= 0) return null;

      const lat = Number(row?.coordinates?.lat);
      const lng = Number(row?.coordinates?.lng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

      const fallbackName = userType === 'creator'
        ? `Creator ${userId}`
        : (userType === 'creator_staff' ? `Staff ${userId}` : `Member ${userId}`);

      return {
        userType,
        userId,
        userKey: String(row?.userKey || `${userType}:${userId}`).trim(),
        memberUserId: userType === 'member' ? userId : null,
        staffUserId: userType === 'creator_staff' ? userId : null,
        sessionUid: String(row?.sessionUid || '').trim(),
        displayName: String(row?.displayName || '').trim() || fallbackName,
        roleLabel: String(row?.roleLabel || '').trim() || (userType === 'creator' ? 'Admin' : (userType === 'creator_staff' ? 'Staff' : 'Member')),
        email: String(row?.email || '').trim(),
        profilePic: sanitizeImageUrl(row?.profilePic),
        deviceType: String(row?.deviceType || '').trim().toLowerCase() || 'unknown',
        locationLabel: String(row?.locationLabel || '').trim() || 'Unknown location',
        locationCity: String(row?.locationCity || '').trim() || '',
        locationRegion: String(row?.locationRegion || '').trim() || '',
        locationCountry: String(row?.locationCountry || '').trim() || '',
        loginAt: row?.loginAt || null,
        lastSeenAt: row?.lastSeenAt || null,
        sessionStatus: String(row?.sessionStatus || row?.status || '').trim().toLowerCase() || 'active',
        isApproximateLocation: Boolean(row?.coordinates?.isApproximate),
        coordinates: { lat, lng },
      };
    })
    .filter(Boolean);
}

function normalizeSummaryWindow(summary, normalizedMembers = []) {
  const fromSummary = {
    totalUsers: Number(summary?.totalUsers),
    desktopUsers: Number(summary?.desktopUsers),
    mobileUsers: Number(summary?.mobileUsers),
    otherUsers: Number(summary?.otherUsers),
  };

  const hasSummary = Number.isFinite(fromSummary.totalUsers)
    && Number.isFinite(fromSummary.desktopUsers)
    && Number.isFinite(fromSummary.mobileUsers);

  if (hasSummary) {
    return {
      totalUsers: Math.max(0, Math.trunc(fromSummary.totalUsers)),
      desktopUsers: Math.max(0, Math.trunc(fromSummary.desktopUsers)),
      mobileUsers: Math.max(0, Math.trunc(fromSummary.mobileUsers)),
      otherUsers: Math.max(0, Math.trunc(Number.isFinite(fromSummary.otherUsers) ? fromSummary.otherUsers : 0)),
    };
  }

  const totals = normalizedMembers.reduce((acc, member) => {
    const type = String(member?.deviceType || '').toLowerCase();
    if (type === 'desktop') acc.desktopUsers += 1;
    else if (type === 'mobile') acc.mobileUsers += 1;
    else acc.otherUsers += 1;
    return acc;
  }, {
    totalUsers: normalizedMembers.length,
    desktopUsers: 0,
    mobileUsers: 0,
    otherUsers: 0,
  });

  return {
    totalUsers: Number(totals.totalUsers || 0),
    desktopUsers: Number(totals.desktopUsers || 0),
    mobileUsers: Number(totals.mobileUsers || 0),
    otherUsers: Number(totals.otherUsers || 0),
  };
}

function normalizeOverviewSummary(summary, membersByWindow = { last30: [], live: [] }) {
  const summaryLast30 = summary?.last30 && typeof summary.last30 === 'object'
    ? summary.last30
    : summary;
  const summaryLive = summary?.live && typeof summary.live === 'object'
    ? summary.live
    : {};

  return {
    last30: normalizeSummaryWindow(summaryLast30, membersByWindow.last30 || []),
    live: normalizeSummaryWindow(summaryLive, membersByWindow.live || []),
  };
}

function normalizeOverviewMembersByWindow(payload) {
  const membersByWindow = payload?.membersByWindow && typeof payload.membersByWindow === 'object'
    ? payload.membersByWindow
    : {};

  const last30Rows = Array.isArray(membersByWindow.last30)
    ? membersByWindow.last30
    : (Array.isArray(payload?.members) ? payload.members : []);
  const liveRows = Array.isArray(membersByWindow.live)
    ? membersByWindow.live
    : last30Rows;

  return {
    last30: normalizeOverviewMembers(last30Rows),
    live: normalizeOverviewMembers(liveRows),
  };
}

const allOverviewMembers = computed(() => {
  const unionMap = new Map();
  const buckets = [overviewMembersByWindow.value?.last30 || [], overviewMembersByWindow.value?.live || []];
  for (const bucket of buckets) {
    for (const member of bucket) {
      const key = String(member?.userKey || '').trim();
      if (!key || unionMap.has(key)) continue;
      unionMap.set(key, member);
    }
  }
  return Array.from(unionMap.values());
});

const liveOverviewUserKeySet = computed(() => {
  const liveRows = Array.isArray(overviewMembersByWindow.value?.live)
    ? overviewMembersByWindow.value.live
    : [];
  return new Set(
    liveRows
      .map((member) => String(member?.userKey || '').trim())
      .filter(Boolean)
  );
});

const visibleOverviewMembersWithPresence = computed(() => {
  const key = overviewWindow.value === 'live' ? 'live' : 'last30';
  const rows = Array.isArray(overviewMembersByWindow.value?.[key])
    ? overviewMembersByWindow.value[key]
    : [];
  return rows.map((member) => {
    const isMember = String(member?.userType || '').toLowerCase() === 'member';
    const isLiveNow = liveOverviewUserKeySet.value.has(String(member?.userKey || '').trim());
    const fallbackStatus = isLiveNow
      ? 'online'
      : (overviewWindow.value === 'last30' ? 'away' : 'offline');
    const status = isMember
      ? presenceStore.memberStatus(member.userId)
      : fallbackStatus;
    return {
      ...member,
      presenceStatus: status,
      isOnline: status === 'online',
    };
  });
});

function subscribeOverviewMembersPresence() {
  const memberIds = allOverviewMembers.value
    .filter((member) => String(member?.userType || '').toLowerCase() === 'member')
    .map((member) => Number(member.userId || 0))
    .filter((id) => Number.isFinite(id) && id > 0);

  if (!memberIds.length) return;
  websocketStore.send({
    type: 'creator',
    event: 'presence:subscribeMembers',
    payload: { memberIds },
  });
}

async function loadOverviewMapData({ silent = false } = {}) {
  if (!silent) {
    isLoadingOverviewMap.value = true;
  }
  overviewMapError.value = '';

  try {
    const requestPaths = [
      '/api/analytics/overview/map',
      '/api/creators/analytics/overview/map',
    ];
    const requestBases = Array.from(new Set(
      [apiProxyUrl, apiBackendUrl]
        .map((value) => String(value || '').trim().replace(/\/+$/, ''))
        .filter(Boolean)
    ));

    let lastError = 'Failed to load overview map data';
    let payload = null;
    let matched = false;

    for (const base of requestBases) {
      for (const path of requestPaths) {
        const response = await fetch(`${base}${path}`, {
          method: 'GET',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        });
        const data = await parsePayload(response);
        if (response.ok && data?.success !== false) {
          payload = data;
          matched = true;
          break;
        }

        const rawText = String(data?.__rawText || '').toLowerCase();
        const routeMiss = rawText.includes('<!doctype html') && rawText.includes('cannot get');
        if (routeMiss) {
          continue;
        }
        lastError = String(data?.message || data?.error || `Failed to load overview map data (${response.status})`);
        if (response.status !== 404) break;
      }
      if (matched) break;
    }

    if (!matched || !payload) {
      throw new Error(lastError);
    }

    const normalizedByWindow = normalizeOverviewMembersByWindow(payload || {});
    overviewMembersByWindow.value = normalizedByWindow;
    overviewSummary.value = normalizeOverviewSummary(payload?.summary || {}, normalizedByWindow);
    subscribeOverviewMembersPresence();
    renderOverviewMapMarkers();
  } catch (error) {
    overviewMembersByWindow.value = {
      last30: [],
      live: [],
    };
    overviewSummary.value = createEmptyOverviewSummary();
    overviewMapError.value = String(error?.message || 'Failed to load overview map data');
  } finally {
    isLoadingOverviewMap.value = false;
  }
}

function buildAvatarMarkerIcon(member, { showLabel = false } = {}) {
  const safeName = escapeHtml(member?.displayName || 'User');
  const safeRole = escapeHtml(member?.roleLabel || '');
  const safeEmail = escapeHtml(member?.email || '');
  const safeLocation = escapeHtml(member?.locationLabel || 'Unknown location');
  const safeLoginAt = escapeHtml(formatDateTime(member?.loginAt));
  const safeLastSeenAt = escapeHtml(formatDateTime(member?.lastSeenAt));
  const safeImage = sanitizeImageUrl(member?.profilePic);
  const initials = escapeHtml(initialsFor(member?.displayName || member?.email));
  const status = member?.isOnline
    ? 'online'
    : (overviewWindow.value === 'last30' ? 'recent' : 'offline');

  let avatarBody = '';
  if (safeImage) {
    avatarBody = `<img src="${safeImage}" alt="${safeName}" class="pl-map-avatar-img" />`;
  } else {
    avatarBody = `<div class="pl-map-avatar-fallback">${initials}</div>`;
  }
  const statusDotClass = status === 'online' ? 'online' : 'recent';
  const statusDot = `<span class="pl-map-status-dot ${statusDotClass}"></span>`;

  const labelHtml = showLabel && member?.isOnline
    ? `<div class="pl-map-label"><div class="pl-map-label-name">${safeName}</div>${safeEmail ? `<div class="pl-map-label-email">${safeEmail}</div>` : ''}</div>`
    : '';

  const html = `
    <div class="pl-map-marker ${status}">
      <div class="pl-map-marker-pin">
        <div class="pl-map-avatar-shell">
          ${avatarBody}
        </div>
        ${statusDot}
      </div>
      ${labelHtml}
    </div>
  `;

  const iconSize = showLabel && member?.isOnline ? [236, 74] : [44, 44];
  const iconAnchor = showLabel && member?.isOnline ? [20, 20] : [20, 20];

  return {
    icon: L.divIcon({
      className: 'pl-map-div-icon',
      html,
      iconSize,
      iconAnchor,
    }),
    popupHtml: `
      <div class="space-y-1">
        <div style="font-weight:600;">${safeName}</div>
        ${safeRole ? `<div>${safeRole}</div>` : ''}
        ${safeEmail ? `<div>${safeEmail}</div>` : ''}
        <div><strong>Location:</strong> ${safeLocation}</div>
        <div><strong>Login:</strong> ${safeLoginAt}</div>
        <div><strong>Last Seen:</strong> ${safeLastSeenAt}</div>
      </div>
    `,
  };
}

function renderOverviewMapMarkers() {
  if (!map || !markersLayer) return;
  if (isRenderingOverviewMarkers) return;

  isRenderingOverviewMarkers = true;
  try {
    markersLayer.clearLayers();

    const members = Array.isArray(visibleOverviewMembersWithPresence.value)
      ? visibleOverviewMembersWithPresence.value
      : [];
    if (!members.length) return;

    const showLabels = Number(map.getZoom?.() || 0) >= 6;
    const points = [];

    members.forEach((member) => {
      const lat = Number(member?.coordinates?.lat);
      const lng = Number(member?.coordinates?.lng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

      const markerIcon = buildAvatarMarkerIcon(member, { showLabel: showLabels });
      const marker = L.marker([lat, lng], {
        icon: markerIcon.icon,
        keyboard: false,
        bubblingMouseEvents: true,
      });
      marker.bindPopup(markerIcon.popupHtml);
      marker.addTo(markersLayer);
      points.push([lat, lng]);
    });

    if (!mapAutoFitDone && points.length) {
      mapAutoFitDone = true;
      const bounds = L.latLngBounds(points);
      window.setTimeout(() => {
        if (!map) return;
        map.fitBounds(bounds, { padding: [36, 36], maxZoom: 6 });
      }, 0);
    }
  } finally {
    isRenderingOverviewMarkers = false;
  }
}

function initMap() {
  if (mapReady.value) return;

  map = L.map('overview-analytics-map', {
    center: [27, -18],
    zoom: 2.5,
    minZoom: 2,
    maxZoom: 8,
    zoomSnap: 0.25,
    scrollWheelZoom: false,
    maxBounds: [[-82, -190], [85, 190]],
    maxBoundsViscosity: 0.75,
  });

  const localBasemap = addLocalWorldBasemap(L, map, { theme: 'light' });
  const streetMapApiBase = [apiProxyUrl, apiBackendUrl]
    .map((value) => String(value || '').trim().replace(/\/+$/, ''))
    .find(Boolean);
  if (streetMapApiBase) {
    void addSelfHostedStreetBasemap(L, map, {
      url: `${streetMapApiBase}/api/creators/map-tiles/north-america.pmtiles`,
      theme: 'light',
    }).then((loadedLayer) => {
      if (!map || !loadedLayer) return;
      localBasemap.setStreetDetailAvailable(true);
    });
  }

  markersLayer = L.layerGroup().addTo(map);
  map.on('zoomend moveend', () => {
    renderOverviewMapMarkers();
  });

  map.attributionControl.setPrefix(false);
  map.attributionControl.remove();
  mapReady.value = true;
  renderOverviewMapMarkers();
}

async function loadNewsfeedInstances() {
  try {
    const res = await fetch(`${apiProxyUrl}/api/feature-instances`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!res.ok) {
      throw new Error(`Failed to fetch feature instances: ${res.status}`);
    }

    const data = await res.json().catch(() => ({}));
    const rawList =
      data?.instances ||
      data?.featureInstances ||
      data?.items ||
      (Array.isArray(data) ? data : []);

    if (!Array.isArray(rawList)) {
      throw new Error('Unexpected feature-instances payload shape');
    }

    const filtered = rawList.filter((inst) => {
      const featureId = Number(
        inst.feature_id ??
          inst.featureId ??
          inst.feature?.feature_id ??
          inst.feature?.id ??
          0
      );

      if (featureId === 6) return true;
      const name = String(inst.feature_name || inst.name || '').toLowerCase();
      const slug = String(inst.slug || '').toLowerCase();
      return name.includes('newsfeed') || slug.includes('newsfeed');
    });

    newsfeedInstances.value = filtered
      .map((inst) => {
        const id =
          inst.instance_id ??
          inst.feature_instance_id ??
          inst.id;

        const numericId = Number(id);
        if (!Number.isFinite(numericId) || numericId <= 0) return null;

        return {
          id: numericId,
          name:
            inst.custom_name ||
            inst.slug ||
            inst.feature_name ||
            `Newsfeed #${numericId}`,
        };
      })
      .filter(Boolean);

    const currentId = Number(selectedInstanceId.value);
    const currentStillValid = newsfeedInstances.value.some((nf) => Number(nf.id) === currentId);
    if (currentStillValid) {
      selectedInstanceId.value = currentId;
    } else {
      selectedInstanceId.value = newsfeedInstances.value[0]?.id || null;
    }
  } catch (err) {
    analyticsError.value = err?.message || 'Failed to load newsfeed instances';
  }
}

async function loadCourseInstances() {
  try {
    const res = await fetch(`${apiProxyUrl}/api/feature-instances`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) {
      throw new Error(`Failed to fetch feature instances: ${res.status}`);
    }
    const data = await res.json().catch(() => ({}));
    const rawList =
      data?.instances ||
      data?.featureInstances ||
      data?.items ||
      (Array.isArray(data) ? data : []);
    if (!Array.isArray(rawList)) return;

    const filtered = rawList.filter((inst) => {
      const name = String(inst.feature_name || inst.name || '').toLowerCase();
      const slug = String(inst.slug || '').toLowerCase();
      return name.includes('course') || slug.includes('course');
    });

    courseInstances.value = filtered
      .map((inst) => {
        const id = inst.instance_id ?? inst.feature_instance_id ?? inst.id;
        const numericId = Number(id);
        if (!Number.isFinite(numericId) || numericId <= 0) return null;
        return {
          id: numericId,
          name:
            inst.custom_name ||
            inst.slug ||
            inst.feature_name ||
            `Course #${numericId}`,
        };
      })
      .filter(Boolean);
  } catch (err) {
    if (activeTab.value === 'course-progress') {
      courseProgressError.value = err?.message || 'Failed to load course instances';
    }
  }
}

function normalizeCourseProgressRow(raw, idx) {
  return {
    id: String(raw?.id || raw?.progressId || raw?.progress_id || `course-progress-${idx}`),
    memberId: Number(raw?.memberId ?? raw?.member_id ?? 0) || 0,
    featureInstanceId: Number(raw?.featureInstanceId ?? raw?.feature_instance_id ?? 0) || 0,
    memberName: String(raw?.memberName || raw?.member_name || raw?.email || `Member ${idx + 1}`),
    courseName: String(raw?.courseName || raw?.course_name || raw?.courseTitle || 'Course'),
    completionPercent: Number(raw?.completionPercent ?? raw?.completion_percent ?? 0) || 0,
    lessonsCompleted: Number(raw?.lessonsCompleted ?? raw?.lessons_completed ?? 0) || 0,
    lessonsTotal: Number(raw?.lessonsTotal ?? raw?.lessons_total ?? 0) || 0,
    watchMinutes: Number(raw?.watchMinutes ?? raw?.watch_minutes ?? 0) || 0,
    lastActivityAt: raw?.lastActivityAt || raw?.last_activity_at || raw?.updatedAt || raw?.updated_at || null,
    hasCertificate: Boolean(raw?.hasCertificate ?? raw?.has_certificate),
    certificateGeneratedAt: raw?.certificateGeneratedAt || raw?.certificate_generated_at || null,
  };
}

function buildCreatorCertificateViewUrl(row = {}, { download = false } = {}) {
  const idParts = String(row?.id || '').split('-');
  const memberId = Number(row?.memberId || idParts?.[0] || 0);
  const featureInstanceId = Number(row?.featureInstanceId || selectedCourseInstanceId.value || idParts?.[1] || 0);
  const base = String(apiProxyUrl || '').trim();
  if (!memberId || !featureInstanceId || !base) return '';
  const params = new URLSearchParams({
    featureInstanceId: String(featureInstanceId),
  });
  if (download) params.set('download', '1');
  return `${base}/api/creator-course/certificate/member/${encodeURIComponent(String(memberId))}/pdf?${params.toString()}`;
}

function viewMemberCertificate(row = {}) {
  const viewUrl = buildCreatorCertificateViewUrl(row, { download: false });
  const downloadUrl = buildCreatorCertificateViewUrl(row, { download: true });
  if (!viewUrl) return;
  certificateViewerPdfSrc.value = viewUrl;
  certificateViewerDownloadUrl.value = downloadUrl || viewUrl;
  certificateViewerOpen.value = true;
}

async function loadCourseProgressAnalytics() {
  isLoadingCourseProgress.value = true;
  courseProgressError.value = '';
  try {
    const data = await fetchCourseProgressOverview({
      featureInstanceId: selectedCourseInstanceId.value || null,
      q: courseMemberSearch.value || null,
      limit: 200,
      offset: 0,
    });
    const rows = data?.rows || data?.items || data?.progress || (Array.isArray(data) ? data : []);
    courseProgressRows.value = Array.isArray(rows)
      ? rows.map((row, idx) => normalizeCourseProgressRow(row, idx))
      : [];
    const totals = data?.totals || data?.summary || {};
    courseProgressTotals.value = {
      enrolledMembers: Number(totals?.enrolledMembers ?? totals?.enrolled_members ?? 0) || 0,
      startedMembers: Number(totals?.startedMembers ?? totals?.started_members ?? 0) || 0,
      completedMembers: Number(totals?.completedMembers ?? totals?.completed_members ?? 0) || 0,
      avgCompletionPercent: Number(totals?.avgCompletionPercent ?? totals?.avg_completion_percent ?? 0) || 0,
      certificatesGenerated: Number(totals?.certificatesGenerated ?? totals?.certificates_generated ?? 0) || 0,
    };
  } catch (err) {
    courseProgressError.value = err?.message || 'Failed to load course progress analytics';
    courseProgressRows.value = [];
  } finally {
    isLoadingCourseProgress.value = false;
  }
}

async function loadVideoChannelAnalytics() {
  isLoadingVideoChannelAnalytics.value = true;
  videoChannelAnalyticsError.value = '';
  try {
    const params = {
      rangeKey: videoChannelRangeKey.value,
      limit: 12,
    };

    if (selectedVideoChannelInstanceId.value !== 'all') {
      const featureInstanceId = Number(selectedVideoChannelInstanceId.value || 0);
      if (featureInstanceId > 0) {
        params.featureInstanceId = featureInstanceId;
      }
    }

    if (videoChannelRangeKey.value === 'custom') {
      if (!videoChannelCustomFrom.value || !videoChannelCustomTo.value) {
        throw new Error('Choose both custom From and To dates.');
      }
      params.from = videoChannelCustomFrom.value;
      params.to = videoChannelCustomTo.value;
    }

    const data = await fetchVideoChannelAnalytics(params);
    if (!data?.success) {
      throw new Error(data?.error || 'Failed to load video channel analytics');
    }

    videoChannelAnalytics.value = {
      ...emptyVideoChannelAnalytics(),
      ...(data || {}),
    };

    const selectedId = Number(selectedVideoChannelInstanceId.value || 0);
    if (
      selectedVideoChannelInstanceId.value !== 'all'
      && selectedId > 0
      && !videoChannelOptions.value.some((row) => row.featureInstanceId === selectedId)
    ) {
      selectedVideoChannelInstanceId.value = 'all';
    }
  } catch (err) {
    videoChannelAnalyticsError.value = err?.message || 'Failed to load video channel analytics';
    videoChannelAnalytics.value = emptyVideoChannelAnalytics();
  } finally {
    isLoadingVideoChannelAnalytics.value = false;
  }
}

async function loadFlixTheatreAnalytics() {
  isLoadingFlixTheatreAnalytics.value = true;
  flixTheatreAnalyticsError.value = '';
  try {
    const params = {
      rangeKey: flixTheatreRangeKey.value,
      limit: 12,
    };

    if (selectedFlixTheatreInstanceId.value !== 'all') {
      const featureInstanceId = Number(selectedFlixTheatreInstanceId.value || 0);
      if (featureInstanceId > 0) {
        params.featureInstanceId = featureInstanceId;
      }
    }

    if (flixTheatreRangeKey.value === 'custom') {
      if (!flixTheatreCustomFrom.value || !flixTheatreCustomTo.value) {
        throw new Error('Choose both custom From and To dates.');
      }
      params.from = flixTheatreCustomFrom.value;
      params.to = flixTheatreCustomTo.value;
    }

    const data = await fetchFlixTheatreAnalytics(params);
    if (!data?.success) {
      throw new Error(data?.error || 'Failed to load flix theatre analytics');
    }

    flixTheatreAnalytics.value = {
      ...emptyVideoChannelAnalytics(),
      ...(data || {}),
    };

    const selectedId = Number(selectedFlixTheatreInstanceId.value || 0);
    if (
      selectedFlixTheatreInstanceId.value !== 'all'
      && selectedId > 0
      && !flixTheatreOptions.value.some((row) => row.featureInstanceId === selectedId)
    ) {
      selectedFlixTheatreInstanceId.value = 'all';
    }
  } catch (err) {
    flixTheatreAnalyticsError.value = err?.message || 'Failed to load flix theatre analytics';
    flixTheatreAnalytics.value = emptyVideoChannelAnalytics();
  } finally {
    isLoadingFlixTheatreAnalytics.value = false;
  }
}

async function loadStorefrontAnalytics() {
  isLoadingStorefrontAnalytics.value = true;
  storefrontAnalyticsError.value = '';
  try {
    const params = {
      rangeKey: storefrontRangeKey.value,
      limit: 10,
    };

    if (selectedStorefrontInstanceId.value !== 'all') {
      const featureInstanceId = Number(selectedStorefrontInstanceId.value || 0);
      if (featureInstanceId > 0) {
        params.featureInstanceId = featureInstanceId;
      }
    }

    if (storefrontRangeKey.value === 'custom') {
      if (!storefrontCustomFrom.value || !storefrontCustomTo.value) {
        throw new Error('Choose both custom From and To dates.');
      }
      params.from = storefrontCustomFrom.value;
      params.to = storefrontCustomTo.value;
    }

    const data = await fetchStorefrontAnalytics(params);
    if (!data?.success) {
      throw new Error(data?.error || data?.message || 'Failed to load stores analytics');
    }

    storefrontAnalytics.value = {
      ...createEmptyStorefrontAnalytics(),
      ...(data || {}),
    };

    const selectedId = Number(selectedStorefrontInstanceId.value || 0);
    const hasSelected = selectedStorefrontInstanceId.value === 'all'
      || storefrontInstanceSelectOptions.value.some((row) => Number(row.value || 0) === selectedId);
    if (!hasSelected) {
      selectedStorefrontInstanceId.value = 'all';
    }
  } catch (err) {
    storefrontAnalyticsError.value = err?.message || 'Failed to load stores analytics';
    storefrontAnalytics.value = createEmptyStorefrontAnalytics();
  } finally {
    isLoadingStorefrontAnalytics.value = false;
  }
}

async function loadFeaturePaywallAnalytics() {
  isLoadingFeaturePaywallAnalytics.value = true;
  featurePaywallAnalyticsError.value = '';
  try {
    const params = {
      rangeKey: featurePaywallRangeKey.value,
      limit: 20,
    };

    if (selectedFeaturePaywallInstanceId.value !== 'all') {
      const featureInstanceId = Number(selectedFeaturePaywallInstanceId.value || 0);
      if (featureInstanceId > 0) {
        params.featureInstanceId = featureInstanceId;
      }
    }

    if (featurePaywallRangeKey.value === 'custom') {
      if (!featurePaywallCustomFrom.value || !featurePaywallCustomTo.value) {
        throw new Error('Choose both custom From and To dates.');
      }
      params.from = featurePaywallCustomFrom.value;
      params.to = featurePaywallCustomTo.value;
    }

    const data = await fetchFeaturePaywallAnalytics(params);
    if (!data?.success) {
      throw new Error(data?.error || data?.message || 'Failed to load feature payment analytics');
    }

    featurePaywallAnalytics.value = {
      ...createEmptyFeaturePaywallAnalytics(),
      ...(data || {}),
    };

    const selectedId = Number(selectedFeaturePaywallInstanceId.value || 0);
    const hasSelected = selectedFeaturePaywallInstanceId.value === 'all'
      || featurePaywallInstanceSelectOptions.value.some((row) => Number(row.value || 0) === selectedId);
    if (!hasSelected) {
      selectedFeaturePaywallInstanceId.value = 'all';
    }
  } catch (err) {
    featurePaywallAnalyticsError.value = err?.message || 'Failed to load feature payment analytics';
    featurePaywallAnalytics.value = createEmptyFeaturePaywallAnalytics();
  } finally {
    isLoadingFeaturePaywallAnalytics.value = false;
  }
}

async function loadCryptoAnalytics() {
  isLoadingCryptoAnalytics.value = true;
  cryptoAnalyticsError.value = '';
  try {
    const params = {
      rangeKey: cryptoRangeKey.value,
      limit: 10,
    };

    if (cryptoRangeKey.value === 'custom') {
      if (!cryptoCustomFrom.value || !cryptoCustomTo.value) {
        throw new Error('Choose both custom From and To dates.');
      }
      params.from = cryptoCustomFrom.value;
      params.to = cryptoCustomTo.value;
    }

    const data = await fetchCryptoAnalytics(params);
    if (!data?.success) {
      throw new Error(data?.error || data?.message || 'Failed to load crypto analytics');
    }

    cryptoAnalytics.value = {
      ...createEmptyCryptoAnalytics(),
      ...(data || {}),
    };
  } catch (err) {
    cryptoAnalyticsError.value = err?.message || 'Failed to load crypto analytics';
    cryptoAnalytics.value = createEmptyCryptoAnalytics();
  } finally {
    isLoadingCryptoAnalytics.value = false;
  }
}

async function loadMembersAnalytics() {
  isLoadingMembersAnalytics.value = true;
  membersAnalyticsError.value = '';
  try {
    const params = {
      rangeKey: membersRangeKey.value,
      limit: 10,
    };
    if (membersRangeKey.value === 'custom') {
      if (!membersCustomFrom.value || !membersCustomTo.value) {
        throw new Error('Choose both custom From and To dates.');
      }
      params.from = membersCustomFrom.value;
      params.to = membersCustomTo.value;
    }

    const data = await fetchMembersAnalytics(params);
    if (!data?.success) {
      throw new Error(data?.error || data?.message || 'Failed to load members analytics');
    }
    membersAnalytics.value = {
      ...createEmptyMembersAnalytics(),
      ...(data || {}),
    };
  } catch (err) {
    membersAnalyticsError.value = err?.message || 'Failed to load members analytics';
    membersAnalytics.value = createEmptyMembersAnalytics();
  } finally {
    isLoadingMembersAnalytics.value = false;
  }
}

async function loadPostViewAnalytics() {
  if (!selectedInstanceId.value) {
    analyticsPosts.value = [];
    analyticsTotals.value = {
      totalViews: 0,
      feedViews: 0,
      slugViews: 0,
      uniqueViewers: 0,
      viewedPosts: 0,
    };
    return;
  }

  isLoadingAnalytics.value = true;
  analyticsError.value = '';

  try {
    const params = new URLSearchParams({
      featureInstanceId: String(selectedInstanceId.value),
      limit: '100',
      includeCreatorViews: includeCreatorViews.value ? '1' : '0',
    });

    const res = await fetch(
      `${apiProxyUrl}/api/creator-newsfeed/analytics/post-views?${params.toString()}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      }
    );

    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data?.success) {
      throw new Error(data?.error || `Failed loading analytics (${res.status})`);
    }

    analyticsTotals.value = {
      totalViews: Number(data?.totals?.totalViews) || 0,
      feedViews: Number(data?.totals?.feedViews) || 0,
      slugViews: Number(data?.totals?.slugViews) || 0,
      uniqueViewers: Number(data?.totals?.uniqueViewers) || 0,
      viewedPosts: Number(data?.totals?.viewedPosts) || 0,
    };
    analyticsPosts.value = Array.isArray(data?.posts) ? data.posts : [];
  } catch (err) {
    analyticsError.value = err?.message || 'Failed to load post analytics';
  } finally {
    isLoadingAnalytics.value = false;
  }
}

async function loadPostViewers(postId) {
  selectedViewerPostId.value = Number(postId) || null;
  viewerRows.value = [];
  viewersError.value = '';

  if (!selectedViewerPostId.value) return;

  isLoadingViewers.value = true;
  try {
    const params = new URLSearchParams({ limit: '200', offset: '0' });
    params.set('includeCreatorViews', includeCreatorViews.value ? '1' : '0');
    const url = `${apiProxyUrl}/api/creator-newsfeed/analytics/post-views/${encodeURIComponent(
      selectedViewerPostId.value
    )}/viewers?${params.toString()}`;

    const res = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });

    const rawText = await res.text().catch(() => '');
    let data = null;
    try {
      data = rawText ? JSON.parse(rawText) : null;
    } catch (_) {
      data = null;
    }

    if (!res.ok || !data?.success) {
      const backendError =
        (data && (data.error || data.message)) ||
        (rawText ? rawText.slice(0, 200) : null) ||
        `Failed loading viewers (${res.status})`;
      throw new Error(backendError);
    }

    viewerRows.value = Array.isArray(data?.viewers) ? data.viewers : [];
  } catch (err) {
    console.error('[CreatorAnalytics] loadPostViewers error:', err);
    viewersError.value = err?.message || 'Failed to load post viewers';
  } finally {
    isLoadingViewers.value = false;
  }
}

async function openViewersModal(postId) {
  isViewersModalOpen.value = true;
  await loadPostViewers(postId);
}

function clearViewerPanel() {
  selectedViewerPostId.value = null;
  viewerRows.value = [];
  viewersError.value = '';
}

function closeViewersModal() {
  isViewersModalOpen.value = false;
  clearViewerPanel();
}

watch(selectedInstanceId, () => {
  if (isViewersModalOpen.value) {
    closeViewersModal();
  }
  clearViewerPanel();
  if (activeTab.value === 'newsfeed-posts') {
    loadPostViewAnalytics();
  }
});

watch(includeCreatorViews, () => {
  if (activeTab.value !== 'newsfeed-posts') return;
  if (isViewersModalOpen.value && selectedViewerPostId.value) {
    openViewersModal(selectedViewerPostId.value);
    return;
  }
  loadPostViewAnalytics();
});

watch([selectedCourseInstanceId], () => {
  if (activeTab.value === 'course-progress') {
    loadCourseProgressAnalytics();
  }
});

watch(
  [
    selectedVideoChannelInstanceId,
    videoChannelRangeKey,
    videoChannelCustomFrom,
    videoChannelCustomTo,
  ],
  () => {
    if (activeTab.value !== 'video-channels') return;
    if (
      videoChannelRangeKey.value === 'custom'
      && (!videoChannelCustomFrom.value || !videoChannelCustomTo.value)
    ) {
      return;
    }
    loadVideoChannelAnalytics();
  }
);

watch(
  [
    selectedFlixTheatreInstanceId,
    flixTheatreRangeKey,
    flixTheatreCustomFrom,
    flixTheatreCustomTo,
  ],
  () => {
    if (activeTab.value !== 'flix-theatres') return;
    if (
      flixTheatreRangeKey.value === 'custom'
      && (!flixTheatreCustomFrom.value || !flixTheatreCustomTo.value)
    ) {
      return;
    }
    loadFlixTheatreAnalytics();
  }
);

watch(
  [
    selectedStorefrontInstanceId,
    storefrontRangeKey,
    storefrontCustomFrom,
    storefrontCustomTo,
  ],
  () => {
    if (activeTab.value !== 'stores') return;
    if (
      storefrontRangeKey.value === 'custom'
      && (!storefrontCustomFrom.value || !storefrontCustomTo.value)
    ) {
      return;
    }
    loadStorefrontAnalytics();
  }
);

watch(
  [
    selectedFeaturePaywallInstanceId,
    featurePaywallRangeKey,
    featurePaywallCustomFrom,
    featurePaywallCustomTo,
  ],
  () => {
    if (activeTab.value !== 'payment-analytics') return;
    if (
      featurePaywallRangeKey.value === 'custom'
      && (!featurePaywallCustomFrom.value || !featurePaywallCustomTo.value)
    ) {
      return;
    }
    loadFeaturePaywallAnalytics();
  }
);

watch(
  [
    membersRangeKey,
    membersCustomFrom,
    membersCustomTo,
  ],
  () => {
    if (activeTab.value !== 'members') return;
    if (
      membersRangeKey.value === 'custom'
      && (!membersCustomFrom.value || !membersCustomTo.value)
    ) {
      return;
    }
    loadMembersAnalytics();
  }
);

watch(
  [
    cryptoRangeKey,
    cryptoCustomFrom,
    cryptoCustomTo,
  ],
  () => {
    if (activeTab.value !== 'crypto') return;
    if (
      cryptoRangeKey.value === 'custom'
      && (!cryptoCustomFrom.value || !cryptoCustomTo.value)
    ) {
      return;
    }
    loadCryptoAnalytics();
  }
);

watch(
  () => allOverviewMembers.value.map((member) => String(member.userKey || '')).sort().join(','),
  () => {
    subscribeOverviewMembersPresence();
    renderOverviewMapMarkers();
  }
);

watch(overviewWindow, () => {
  if (activeTab.value === 'overview') {
    loadOverviewMapData({ silent: true });
  }
  renderOverviewMapMarkers();
});

watch(
  () => presenceStore.memberPresence,
  () => {
    if (activeTab.value === 'overview') {
      const now = Date.now();
      if (now - lastPresenceDrivenOverviewRefreshAt >= 5000) {
        lastPresenceDrivenOverviewRefreshAt = now;
        loadOverviewMapData({ silent: true });
      }
    }
    renderOverviewMapMarkers();
  },
  { deep: true }
);

watch(activeTab, (tab) => {
  if (tab === 'overview') {
    if (isViewersModalOpen.value) {
      closeViewersModal();
    }
    loadOverviewMapData({ silent: true });
    setTimeout(() => {
      if (!mapReady.value) initMap();
      map?.invalidateSize?.();
      renderOverviewMapMarkers();
    }, 0);
  }
  if (tab === 'members') {
    loadMembersAnalytics();
  }
  if (tab === 'newsfeed-posts') {
    loadPostViewAnalytics();
  }
  if (tab === 'course-progress') {
    loadCourseProgressAnalytics();
  }
  if (tab === 'video-channels') {
    loadVideoChannelAnalytics();
  }
  if (tab === 'flix-theatres') {
    loadFlixTheatreAnalytics();
  }
  if (tab === 'stores') {
    loadStorefrontAnalytics();
  }
  if (tab === 'payment-analytics') {
    loadFeaturePaywallAnalytics();
  }
  if (tab === 'crypto') {
    loadCryptoAnalytics();
  }
});

onMounted(async () => {
  websocketStore.connect();
  initMap();
  await Promise.all([
    loadOverviewMapData(),
    loadNewsfeedInstances(),
    loadCourseInstances(),
  ]);
  overviewMapRefreshTimer = setInterval(() => {
    if (activeTab.value === 'overview') {
      loadOverviewMapData({ silent: true });
    }
  }, 30000);
});

onBeforeUnmount(() => {
  if (overviewMapRefreshTimer) {
    clearInterval(overviewMapRefreshTimer);
    overviewMapRefreshTimer = null;
  }
  if (map) {
    map.remove();
    map = null;
  }
  markersLayer = null;
  mapAutoFitDone = false;
  isRenderingOverviewMarkers = false;
});
</script>

<style scoped>
.overview-map-panel,
.overview-activity-panel {
  height: clamp(570px, calc(100dvh - 210px), 620px);
  max-height: calc(100dvh - 180px);
}

#overview-analytics-map {
  width: 100%;
  position: relative;
  z-index: 1;
}

.leaflet-control-attribution {
  display: none !important;
}

:deep(.leaflet-pane) {
  z-index: 2 !important;
}

:deep(.leaflet-local-world-land-pane) {
  z-index: 2 !important;
}

:deep(.leaflet-local-world-hydro-pane) {
  z-index: 2 !important;
}

:deep(.leaflet-local-world-borders-pane) {
  z-index: 3 !important;
}

:deep(.leaflet-local-world-subdivisions-pane) {
  z-index: 3 !important;
}

:deep(.leaflet-local-world-labels-pane) {
  z-index: 4 !important;
}

:deep(.leaflet-local-world-detail-labels-pane) {
  z-index: 4 !important;
}

:deep(.leaflet-tile-pane) {
  z-index: 2 !important;
}

:deep(.leaflet-overlay-pane) {
  z-index: 3 !important;
}

:deep(.leaflet-shadow-pane) {
  z-index: 4 !important;
}

:deep(.leaflet-marker-pane) {
  z-index: 5 !important;
}

:deep(.leaflet-tooltip-pane) {
  z-index: 6 !important;
}

:deep(.leaflet-popup-pane) {
  z-index: 7 !important;
}

:deep(.leaflet-control-container),
:deep(.leaflet-top),
:deep(.leaflet-bottom) {
  z-index: 8 !important;
}

.leaflet-control-zoom {
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.42) !important;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 4px 14px rgba(51, 65, 85, 0.14);
}

.leaflet-control-zoom a {
  color: #526270 !important;
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

.leaflet-control-zoom a:hover {
  color: #2d8cff !important;
  background-color: #f4f8fb !important;
}

:deep(.local-world-label-shell) {
  display: flex !important;
  align-items: center;
  justify-content: center;
  border: 0 !important;
  background: transparent !important;
  pointer-events: none !important;
}

:deep(.local-world-label) {
  color: #718391;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.015em;
  line-height: 1;
  text-align: center;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.95);
  white-space: nowrap;
}

:deep(.local-city-label-shell),
:deep(.local-subdivision-label-shell) {
  overflow: visible !important;
  border: 0 !important;
  background: transparent !important;
  pointer-events: none !important;
}

:deep(.local-city-label) {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #526574;
  font-size: 9px;
  font-weight: 650;
  line-height: 1;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.98);
  white-space: nowrap;
}

:deep(.local-city-label i) {
  width: 4px;
  height: 4px;
  flex: 0 0 4px;
  border: 1px solid rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  background: #657d8d;
  box-shadow: 0 0 0 1px rgba(101, 125, 141, 0.18);
}

:deep(.local-subdivision-label) {
  display: block;
  color: #81919c;
  font-size: 8px;
  font-weight: 650;
  letter-spacing: 0.04em;
  line-height: 1;
  text-align: center;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.98);
  white-space: nowrap;
}

:deep(.platforma-map-data-attribution) {
  padding: 3px 6px;
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.84);
  font-size: 8px;
  line-height: 1;
  backdrop-filter: blur(5px);
}

:deep(.platforma-map-data-attribution a) {
  color: #6b7c89;
  text-decoration: none;
}

:deep(.pl-map-div-icon) {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
  overflow: visible !important;
}

:deep(.pl-map-div-icon.leaflet-div-icon) {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
  overflow: visible !important;
}

:deep(.pl-map-marker) {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
}

:deep(.pl-map-marker-pin) {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  border-radius: 999px;
  overflow: visible;
  line-height: 0;
  background: transparent;
  padding: 0;
  border: 0;
}

:deep(.pl-map-marker.online .pl-map-marker-pin) {
  border: 0;
  background: transparent;
}

:deep(.pl-map-avatar-shell) {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.18);
  background: transparent;
}

:deep(.pl-map-avatar-img) {
  display: block;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center center;
  border-radius: 999px;
  flex: 0 0 auto;
}

:deep(.pl-map-avatar-shell > img) {
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: cover !important;
  object-position: center center !important;
  border-radius: 999px !important;
}

:deep(.pl-map-avatar-fallback) {
  width: 100%;
  height: 100%;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  background: linear-gradient(135deg, #dbeafe 0%, #93c5fd 100%);
}

:deep(.pl-map-status-dot) {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 13px;
  height: 13px;
  border-radius: 999px;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.35);
  z-index: 6;
}

:deep(.pl-map-status-dot.online) {
  background: #22c55e;
}

:deep(.pl-map-status-dot.recent) {
  background: #f59e0b;
}

:deep(.pl-map-dot) {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #2d8cff;
  border: 2px solid #ffffff;
  box-shadow: 0 8px 20px rgba(45, 140, 255, 0.35);
}

:deep(.pl-map-label) {
  margin-top: 6px;
  max-width: 200px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(148, 163, 184, 0.35);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
  padding: 6px 8px;
  pointer-events: none;
}

:deep(.pl-map-label-name) {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.pl-map-label-email) {
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.2;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ─────────────────────────────────────────────
   Creator layout scrollbar (right column only)
   ─────────────────────────────────────────── */

/* Firefox base */
.app-scroll {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  /* try to keep layout width stable */
  scrollbar-gutter: stable;
}

/* WebKit base (Chrome / Edge / Safari) */
.app-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Hide old-school buttons/arrows (where they exist) */
.app-scroll::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
  background: transparent;
}

/* Track fully invisible so it looks “on top” of content */
.app-scroll::-webkit-scrollbar-track {
  background: transparent;
}

/* Thumb invisible by default */
.app-scroll::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 999px;
}

/* On hover over the scroll area: fade thumb in */
.app-scroll:hover {
  scrollbar-color: rgba(145, 150, 156, 0.541) transparent; /* Firefox */
}

.app-scroll:hover::-webkit-scrollbar-thumb {
  background-color: rgba(140, 143, 148, 0.479);
}

/* Slightly stronger when directly hovering the thumb */
.app-scroll:hover::-webkit-scrollbar-thumb:hover {
  background-color: rgba(203, 213, 225, 0.65);
}
</style>
